import {
  addRemoveGwpItems
} from "./chunk--chunk-H5ERXJ7R.vbt.js";
import {
  cartDataFncs,
  getCartData,
  hasTimeElapsed,
  setCartDataLocalStorage,
  shapeCartData
} from "./chunk--chunk-ZBCSGDEC.vbt.js";
import {
  cartActions,
  cartAddItems,
  cartChange
} from "./chunk--chunk-Q6LIHEMH.vbt.js";
import {
  CART_LINE_ITEM_QUANTITY_MAX_DEFAULT,
  ON_CHANGE_DEBOUNCE_TIMER,
  PRODUCT_PROPERTY_KEYS,
  PRODUCT_SELLING_PLAN_DEFAULT_ID,
  PUB_SUB_EVENTS,
  PUB_SUB_PAYLOADS,
  cartDebug,
  debounce,
  debugOutlineElements,
  getCartDebugState,
  getLocalStorage,
  publish,
  setLocalStorage,
  subscribe
} from "./chunk--chunk-HVXZT5R3.vbt.js";
import "./chunk--chunk-Z7A6LSGX.vbt.js";

// src/js/helpers/ComponentConstructor.js
function initComponentOnConnectedComponentLoad(componentToInit, handleToWatch, selectorDispatch, element, dataSelect) {
  document.addEventListener(handleToWatch + " loaded", function handler() {
    const component = new componentToInit(element, dataSelect);
    if (component.init)
      component.init();
    document.dispatchEvent(new CustomEvent(selectorDispatch + " loaded"));
    this.removeEventListener(handleToWatch + " loaded", handler);
  });
}
function initComponentOnConnectedComponentDomEvent(componentToInit, handleToWatch, trigger, selectorDispatch, element, dataSelect) {
  document.querySelectorAll("[data-" + handleToWatch + "]").forEach(
    (elementTrigger) => elementTrigger.addEventListener(trigger, function handler() {
      const component = new componentToInit(element, dataSelect);
      if (component.init)
        component.init();
      document.dispatchEvent(new CustomEvent(selectorDispatch + " loaded"));
      this.removeEventListener(trigger, handler);
    })
  );
}
function initComponentOnSelfDomEvent(componentToInit, trigger, selectorDispatch, element, dataSelect) {
  if (window.innerWidth < 768 && trigger === "mouseover") {
    initComponentOnSelfIntersection(
      componentToInit,
      selectorDispatch,
      element,
      dataSelect
    );
  } else {
    element.addEventListener(trigger, function handler() {
      const component = new componentToInit(element, dataSelect);
      if (component.init)
        component.init();
      document.dispatchEvent(new CustomEvent(selectorDispatch + " loaded"));
      this.removeEventListener(trigger, handler);
    });
  }
}
function initComponentOnSelfIntersection(componentToInit, selectorDispatch, element, dataSelect) {
  const component = new componentToInit(element, dataSelect);
  if (component.init) {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        component.init();
        document.dispatchEvent(new CustomEvent(selectorDispatch + " loaded"));
        observer.disconnect();
      }
    }, {
      rootMargin: "300px 0px 0px 0px"
    });
    observer.observe(element);
  }
}
function ComponentConstructor(components) {
  Object.entries(components).forEach(([selector, Component]) => {
    const dataSelect = "data-" + selector;
    const matchedElements = document.querySelectorAll("[" + dataSelect + "]");
    matchedElements.forEach((element) => {
      if (Array.isArray(Component)) {
        if (Component.filter((option) => typeof option === "string" && option.includes("url:")).length > 0) {
          const urls = Component.map((option) => typeof option === "string" && option.includes("url:") ? option.split("url:")[1] : false);
          let shouldInit = false;
          for (const url of urls) {
            if (url && window.location.href.includes(url)) {
              shouldInit = true;
            }
          }
          if (shouldInit) {
            initComponentOnSelfIntersection(
              Component[0],
              selector,
              element,
              dataSelect
            );
            return;
          }
        }
        Component.forEach((option, i) => {
          if (i === 0 || option.includes("url:"))
            return;
          if (option.includes(":")) {
            const triggerType = option.split(":")[0];
            const triggerSelector = option.split(":")[1];
            if (triggerType === "load") {
              initComponentOnConnectedComponentLoad(
                Component[0],
                triggerSelector,
                selector,
                element,
                dataSelect
              );
            } else {
              initComponentOnConnectedComponentDomEvent(
                Component[0],
                triggerSelector,
                triggerType,
                selector,
                element,
                dataSelect
              );
            }
          } else {
            initComponentOnSelfDomEvent(
              Component[0],
              option,
              selector,
              element,
              dataSelect
            );
          }
        });
        return;
      }
      initComponentOnSelfIntersection(Component, selector, element, dataSelect);
    });
  });
}

// src/js/customElements/cart.js
var CartRemoveButton = class extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      this?.classList.toggle("opacity-40");
      this?.classList.toggle("pointer-events-none");
      cartActions.cartChange({
        id: this.dataset.key,
        quantity: 0
      });
    });
  }
};
customElements.define("cart-remove-button", CartRemoveButton);
var CartLoadingSpinner = class extends HTMLElement {
  constructor() {
    super();
    this.cartItemKey = this.dataset["cartItemKey"];
  }
  connectedCallback() {
    this.cartLoadingUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartInFlight,
      (payload) => {
        if (this.cartItemKey && payload.id !== this.cartItemKey) {
          return;
        }
        if (payload.isInFlight === true) {
          this.enableLoading();
        } else {
          this.disableLoading();
        }
      },
      "cartLoadingSpinner"
    );
  }
  disconnectedCallback() {
    if (this.cartLoadingUnsubscriber) {
      this.cartLoadingUnsubscriber();
    }
  }
  enableLoading() {
    this.classList.remove("hidden");
  }
  disableLoading() {
    this.classList.add("hidden");
  }
};
customElements.define("cart-loading-spinner", CartLoadingSpinner);
var CartCustomElement = class extends HTMLElement {
  constructor() {
    super();
    this.cartInFlightDebugUnsubscriber = null;
  }
  connectedCallback() {
    this.cartInFlightDebugUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartInFlight,
      (payload) => {
        if (payload.isInFlight === true) {
          this.enableDebugOutline();
        }
      },
      "cartInFlight"
    );
  }
  disconnectedCallback() {
    if (this.cartInFlightDebugUnsubscriber) {
      this.cartInFlightDebugUnsubscriber();
    }
  }
  enableDebugOutline() {
    if (getCartDebugState() === true) {
      debugOutlineElements([this.firstElementChild], "yellow", 0);
    }
  }
};
customElements.define("cart-custom-element", CartCustomElement);
var CartInFlight = class extends HTMLElement {
  constructor() {
    super();
    this.cartLoadingUnsubscriber = null;
    this.cartItemKey = this.dataset["cartItemKey"];
    this.spinner = this.querySelector(".loading__spinner_spinner");
    this.childToHide = this.querySelector(".loading__spinner_child");
    this.mask = this.querySelector(".loading__spinner_mask");
    this.showSpinner = this.dataset["cartInFlightShowSpinner"] === "true";
    this.maskChild = this.dataset["cartInFlightMaskChild"] === "true";
    this.dimChild = this.dataset["cartInFlightDimChild"] === "true";
    this.hideChild = this.dataset["cartInFlightHideChild"] === "true";
    this.classToDimChild = this.hideChild ? "opacity-0" : "opacity-40";
  }
  connectedCallback() {
    this.cartLoadingUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartInFlight,
      (payload) => {
        if (this.cartItemKey && payload.id !== this.cartItemKey) {
          return;
        }
        if (payload.isInFlight === true) {
          this.enableLoading();
        } else {
          this.disableLoading();
        }
      },
      "cartInFlight"
    );
  }
  disconnectedCallback() {
    if (this.cartLoadingUnsubscriber) {
      this.cartLoadingUnsubscriber();
    }
  }
  enableLoading() {
    if (getCartDebugState() === true) {
      debugOutlineElements([this.childToHide], "blue", 0);
    }
    this.showSpinner && this.spinner?.classList.remove("hidden");
    this.showSpinner && this.spinner?.classList.add("flex");
    this.maskChild && this.mask?.classList.remove("hidden");
    this.dimChild && this.childToHide?.classList.add(this.classToDimChild);
  }
  disableLoading() {
    this.spinner?.classList.add("hidden");
    this.spinner?.classList.remove("flex");
    this.mask?.classList.add("hidden");
    this.childToHide?.classList.remove(this.classToDimChild);
  }
};
customElements.define("cart-in-flight", CartInFlight);
var CartItems = class extends HTMLElement {
  constructor() {
    super();
    this.cartDebugState = getCartDebugState();
  }
  connectedCallback() {
    this.cartLoadingUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartInFlight,
      (payload) => {
        if (payload.isInFlight === true) {
          this.enableLoading({ key: payload.id, line: payload.line });
        } else {
          this.disableLoading({ key: payload.id, line: payload.line });
        }
      },
      "cartItems"
    );
    if (this.cartDebugState === true) {
      this.addDebugUI();
    }
  }
  disconnectedCallback() {
    if (this.cartLoadingUnsubscriber) {
      this.cartLoadingUnsubscriber();
    }
  }
  addStylesheet(styleString) {
    var styleEl = document.createElement("style");
    styleEl.innerText = styleString;
    this.prepend(styleEl);
  }
  addDebugUI() {
    this.addStylesheet(`
      .debug-controls {
        border: 2px solid yellow;
      }
      .debug-controls button {
        padding: 4px;
      }
    `);
    const debugControls = document.createElement("div");
    debugControls.classList.add("debug-controls");
    const refreshCart = document.createElement("button");
    refreshCart.textContent = "Refresh Cart";
    refreshCart.addEventListener("click", () => {
      cartActions.cartRefresh();
    });
    debugControls.append(refreshCart);
    const clearCart = document.createElement("button");
    clearCart.textContent = "Clear Cart";
    clearCart.addEventListener("click", () => {
      cartActions.cartClear();
    });
    debugControls.append(clearCart);
    this.prepend(debugControls);
  }
  enableLoading({ key, line }) {
    this.classList.add("pointer-events-none");
    document.activeElement?.blur();
  }
  disableLoading({ key, line }) {
    this.classList.remove("pointer-events-none");
  }
};
customElements.define("cart-items", CartItems);

// src/js/customElements/free-shipping-bar.js
var FreeShippingBar = class extends HTMLElement {
  constructor() {
    super();
    this.cartTotal = parseInt(this.dataset["cartTotal"] ?? "0");
    this.threshold = parseInt(this.dataset["threshold"] ?? "0");
    this.elProgress = this.querySelector("[data-progress]");
    this.elRemaining = this.querySelector("[data-remaining]");
    this.elContent = this.querySelector("[data-freeship-content]");
    this.elAchievedContent = this.querySelector("[data-freeship-achieved]");
  }
  connectedCallback() {
    this.updateElements(this.cartTotal);
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartMutationComplete,
      (payload) => {
        this.onCartUpdate(payload.cartData.cartRaw.total_price);
      },
      "freeShippingBar"
    );
  }
  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }
  onCartUpdate(totalPrice) {
    this.updateElements(totalPrice);
  }
  updateElements(cartPrice) {
    const newRemaining = (this.threshold - cartPrice) / 100;
    let percent = 100 - newRemaining * 100 / this.threshold * 100;
    if (percent == 0) {
      percent = 1;
    }
    if (this.elProgress && this.elContent && this.elAchievedContent) {
      this.elProgress.style.width = percent + "%";
      if (newRemaining > 0) {
        this.elContent.style.display = "block";
        this.elAchievedContent.style.display = "none";
      } else {
        this.elContent.style.display = "none";
        this.elAchievedContent.style.display = "block";
      }
    }
  }
};
customElements.define("free-shipping-bar", FreeShippingBar);

// src/js/customElements/input-select-subscription.js
var InputSelectSubscription = class extends HTMLElement {
  constructor() {
    super();
    this.productFormId = this.dataset["productFormId"];
    this.defaultSellingPlanId = this.dataset["defaultSellingPlanId"];
    this.itemKey = this.dataset["itemKey"];
    this.line = this.dataset["line"];
    this.quantity = this.dataset["quantity"];
    this.productId = this.dataset["productId"];
    this.elSelect = this.querySelector("select");
    this.elOptions = this.querySelectorAll("option");
    this.elFacadeSpan = this.querySelector(
      "[data-input-select-subscription-facade] > span"
    );
    this.elMask = this.querySelector("[data-input-select-subscription-mask]");
    this.elAdditionalSubscriptionInfo = document.querySelector(
      `[data-input-select-subscription-additionalSubscriptionInfo="${this.itemKey}"]`
    );
    this.elAdditionalSubscriptionInfoSpan = this.elAdditionalSubscriptionInfo?.querySelector("span");
    this.stringSeparatorForAdditionalSubscriptionInfo = "- ";
  }
  connectedCallback() {
    if (this.defaultSellingPlanId) {
      this.updateProductFormSellingPlan(this.defaultSellingPlanId);
    }
    this.updateFacadeTextContent();
    this.elSelect?.addEventListener("change", this.handleSelectChange);
  }
  disconnectedCallback() {
    this.elSelect?.removeEventListener("change", this.handleSelectChange);
  }
  updateFacadeTextContent = () => {
    for (let el of this.elOptions) {
      let isSelected = el.selected;
      if (isSelected) {
        let textFromSelectOption = el.textContent ?? "";
        let separateSubscriptionDurationAndAdditionalInfo = textFromSelectOption.split(
          this.stringSeparatorForAdditionalSubscriptionInfo
        );
        let textFromSelectOptionWithoutAdditionalInfo = separateSubscriptionDurationAndAdditionalInfo[0];
        if (this.elFacadeSpan) {
          this.elFacadeSpan.textContent = textFromSelectOptionWithoutAdditionalInfo;
        }
        let additionalInfo = separateSubscriptionDurationAndAdditionalInfo[1];
        if (this.elAdditionalSubscriptionInfo && this.elAdditionalSubscriptionInfoSpan) {
          if (additionalInfo) {
            this.elAdditionalSubscriptionInfoSpan.textContent = additionalInfo;
            this.elAdditionalSubscriptionInfo.classList.remove("hidden");
          } else {
            this.elAdditionalSubscriptionInfoSpan.textContent = "";
            this.elAdditionalSubscriptionInfo.classList.add("hidden");
          }
        }
        break;
      }
    }
  };
  updateProductFormSellingPlan = (sellingPlanId = PRODUCT_SELLING_PLAN_DEFAULT_ID) => {
    publish(
      PUB_SUB_EVENTS.productSellingPlanChange,
      {
        productFormId: this.productFormId,
        sellingPlanId
      },
      "input-select-subscription"
    );
  };
  updateCartLineItemSellingPlan = (sellingPlanId = PRODUCT_SELLING_PLAN_DEFAULT_ID) => {
    if (this.elSelect) {
      this.elSelect.disabled = true;
    }
    if (this.elMask) {
      this.elMask.classList.remove("hidden");
    }
    cartChange({
      id: this.itemKey,
      quantity: this.quantity,
      sellingPlanId,
      properties: {
        [PRODUCT_PROPERTY_KEYS.isSubscription]: sellingPlanId ? true : false
      }
    });
  };
  handleSelectChange = (event) => {
    console.log(event.target.value);
    event.stopPropagation();
    this.updateFacadeTextContent();
    let options = event.target.options;
    let selectedIndex = event.target.selectedIndex;
    let selectedOption = options[selectedIndex];
    let sellingPlanId = selectedOption.getAttribute(
      "data-option-sellingPlanId"
    );
    const cartItems = this.closest("cart-items");
    if (this.itemKey && cartItems) {
      this.updateCartLineItemSellingPlan(sellingPlanId);
    } else {
      this.updateProductFormSellingPlan(sellingPlanId);
    }
  };
};
customElements.define("input-select-subscription", InputSelectSubscription);

// src/js/customElements/subscription-widget.js
var SubscriptionWidget = class extends HTMLElement {
  constructor() {
    super();
    this.productFormId = this.dataset["productFormId"];
    this.elSelect = this.querySelector("input-select-subscription select");
    this.elInputOnetime = this.querySelector("input#purchaseType--onetime");
    this.elInputSubscription = this.querySelector(
      "input#purchaseType--subscription"
    );
  }
  updateProductFormSellingPlan = (sellingPlanId = PRODUCT_SELLING_PLAN_DEFAULT_ID) => {
    publish(
      PUB_SUB_EVENTS.productSellingPlanChange,
      {
        productFormId: this.productFormId,
        sellingPlanId
      },
      "subscription-widget"
    );
  };
  handleChangePurchaseTypeOneTime = (event) => {
    const value = event.target.value;
    cartDebug("SubscriptionWidget handleChangePurchaseType:", value);
    this.updateProductFormSellingPlan(PRODUCT_SELLING_PLAN_DEFAULT_ID);
  };
  handleChangePurchaseTypeSubscription = (event) => {
    const value = event.target.value;
    cartDebug("SubscriptionWidget handleChangePurchaseType:", value);
    if (this.elSelect) {
      let options = this.elSelect.options;
      let selectedIndex = this.elSelect.selectedIndex;
      let selectedOption = options[selectedIndex];
      let sellingPlanId = selectedOption.getAttribute(
        "data-option-sellingPlanId"
      );
      this.updateProductFormSellingPlan(sellingPlanId);
    }
  };
  connectedCallback() {
    this.elInputSubscription?.addEventListener(
      "input",
      this.handleChangePurchaseTypeSubscription
    );
    this.elInputOnetime?.addEventListener(
      "input",
      this.handleChangePurchaseTypeOneTime
    );
  }
  disconnectedCallback() {
    this.elInputSubscription?.removeEventListener(
      "input",
      this.handleChangePurchaseTypeSubscription
    );
    this.elInputOnetime?.removeEventListener(
      "input",
      this.handleChangePurchaseTypeOneTime
    );
  }
};
customElements.define("subscription-widget", SubscriptionWidget);

// src/js/customElements/quantity-input.js
var QuantityInput = class extends HTMLElement {
  constructor() {
    super();
    this.productFormId = this.dataset["productFormId"];
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.buttonIncrease = this.querySelector("button[data-quantity-increase]");
    this.buttonDecrease = this.querySelector("button[data-quantity-decrease]");
    this.min = parseInt(this.dataset["min"] ?? "1");
  }
  connectedCallback() {
    this.input?.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach(
      (button) => button.addEventListener("click", this.onButtonClick.bind(this))
    );
    this.updateQuantityButtonsState();
  }
  disconnectedCallback() {
    this.input?.removeEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach(
      (button) => button.removeEventListener("click", this.onButtonClick.bind(this))
    );
  }
  resetQuantityInput(id) {
    cartDebug("resetQuantityInput", id);
    if (this.input) {
      this.input.value = this.input.getAttribute("value") ?? this.min.toString();
      cartDebug("Quantity RESET to:", this.input.value);
      this.updateQuantityButtonsState();
    }
  }
  handleInvalidInput(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }
  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    const key = event.target.dataset.key;
    const min = parseInt(event.target.dataset.min);
    const max = parseInt(event.target.dataset.max);
    const step = parseInt(event.target.step);
    let message = "";
    if (inputValue < min) {
      message = window.quickOrderListStrings.min_error.replace("[min]", min);
    } else if (inputValue > max) {
      message = window.quickOrderListStrings.max_error.replace("[max]", max);
    } else if (inputValue % step !== 0) {
      message = window.quickOrderListStrings.step_error.replace("[step]", step);
    }
    if (message) {
      cartDebug({ message });
      this.handleInvalidInput(event, index, message);
    } else {
      event.target.setCustomValidity("");
      event.target.reportValidity();
      if (this.productFormId) {
        publish(PUB_SUB_EVENTS.productQuantityChange, {
          productFormId: this.productFormId,
          quantity: inputValue
        });
      } else {
        cartChange({
          id: key,
          quantity: inputValue
        });
      }
    }
  }
  onInputChange(event) {
    this.updateQuantityButtonsState();
    cartDebug("Quantity changed to:", event.target.value);
    this.validateQuantity(event);
  }
  // note: cart.js validateQuantity() handles enforcing min/max/step and resetting invalid input; this function is somewhat redundant; consider whether to consolidate;
  onButtonClick(event) {
    event.preventDefault();
    if (!this.input)
      return;
    const previousValue = this.input.value;
    if (event.target.name === "plus") {
      if (this.min > parseInt(this.input.step) && parseInt(this.input.value) <= this.min) {
        this.input.value = this.min.toString();
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }
    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }
    if (this.min === parseInt(previousValue) && event.target.name === "minus") {
      this.input.value = this.min.toString();
    }
  }
  updateQuantityButtonsState() {
    const value = this.input?.value;
    const min = this.input?.dataset.min;
    const max = this.input?.dataset.max;
    if (value) {
      if (min) {
        let valAtMin = parseInt(value) <= parseInt(min);
        this.buttonDecrease?.classList.toggle("opacity-50", valAtMin);
        this.buttonDecrease?.classList.toggle("pointer-events-none", valAtMin);
      }
      if (max) {
        let valAtMax = parseInt(value) >= parseInt(max);
        this.buttonIncrease?.classList.toggle("opacity-50", valAtMax);
        this.buttonIncrease?.classList.toggle("pointer-events-none", valAtMax);
      }
    }
  }
};
customElements.define("quantity-input", QuantityInput);

// src/js/customElements/quick-add.js
var DATA_IDENTIFIER = "[data-quick-add]";
var LABELS = {
  add: "Add [fallback copy]",
  remove: "Remove [fallback copy]",
  max: "Max [fallback copy]"
};
var QuickAdd = class extends HTMLElement {
  constructor() {
    super();
    this.productFormId = this.dataset["productFormId"];
    this.sellingPlanId = this.dataset["defaultSellingPlanId"] ? parseInt(this.dataset["defaultSellingPlanId"]) : PRODUCT_SELLING_PLAN_DEFAULT_ID;
    this.variantId = parseInt(this.dataset["quickAddVariantId"] ?? "0");
    this.addQuantity = parseInt(this.dataset["quickAddQuantity"] ?? "1");
    this.maxQuantity = parseInt(
      this.dataset["quickAddMaxQuantity"] ?? `${CART_LINE_ITEM_QUANTITY_MAX_DEFAULT}`
    );
    this.quantityInCart = 0;
    this.size = this.dataset["quickAddSize"];
    this.groupSelector = this.dataset["groupSelector"];
    this.itemCartKey = this.dataset["quickAddItemCartKey"];
    this.itemInCartClass = this.dataset["quickAddItemInCartClass"] ?? "item-in-cart";
    this.labelAdd = this.dataset["quickAddLabelAdd"] ?? LABELS.add;
    this.labelRemove = this.dataset["quickAddLabelRemove"] ?? LABELS.remove;
    this.labelMax = this.dataset["quickAddLabelMax"] ?? LABELS.max;
    this.isFreeSample = this.hasAttribute("data-quick-add-free-sample");
    this.freeSampleMax = parseInt(this.dataset["quickAddFreeSampleMax"] ?? "0");
    this.freeSampleCartCount = parseInt(
      this.dataset["quickAddFreeSampleCartCount"] ?? "0"
    );
    this.button = this.querySelector("button");
    this.buttonLabel = this.button?.querySelector(
      "[data-quick-add-button-label]"
    );
    this.buttonAction = "add";
    this.buttonAction = this.addItem;
    this.cartUpdateUnsubscriber = null;
    this.quantityChangeUnsubscriber = null;
  }
  async connectedCallback() {
    this.quantityInCart = await cartDataFncs.getVariantQuantitySellingPlanInCart(
      this.variantId,
      this.sellingPlanId
    );
    this.updateElements();
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartMutationComplete,
      async (payload) => {
        await this.onCartUpdate(payload.cartData);
      },
      "quickAdd"
    );
    if (this.productFormId) {
      this.quantityChangeUnsubscriber = subscribe(
        PUB_SUB_EVENTS.productQuantityChange,
        ({ productFormId, quantity }) => {
          this.onQuantityChange(productFormId, quantity);
        },
        "quickAdd"
      );
      this.quantityChangeUnsubscriber = subscribe(
        PUB_SUB_EVENTS.productSellingPlanChange,
        async ({ productFormId, sellingPlanId }) => {
          this.onSellingPlanChange(productFormId, sellingPlanId);
        },
        "quickAdd"
      );
    }
  }
  disconnectedCallback() {
    this.removeEventListeners();
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
    if (this.quantityChangeUnsubscriber) {
      this.quantityChangeUnsubscriber();
    }
  }
  onQuantityChange(productFormId, quantity) {
    cartDebug(
      "QuickAdd onQuantityChange",
      productFormId,
      this.productFormId,
      quantity
    );
    if (this.productFormId && this.productFormId === productFormId) {
      this.addQuantity = quantity;
      this.updateElements();
    }
  }
  showPriceForSellingPlan(sellingPlanId) {
    if (sellingPlanId === PRODUCT_SELLING_PLAN_DEFAULT_ID) {
      this.querySelectorAll(".product_atc_label_price_subscription").forEach(
        (el) => {
          el.classList.add("hidden");
        }
      );
      this.querySelectorAll(".product_atc_label_price_onetime").forEach(
        (el) => {
          el.classList.remove("hidden");
        }
      );
    } else {
      this.querySelectorAll(".product_atc_label_price_subscription").forEach(
        (el) => {
          el.classList.remove("hidden");
        }
      );
      this.querySelectorAll(".product_atc_label_price_onetime").forEach(
        (el) => {
          el.classList.add("hidden");
        }
      );
    }
  }
  async onSellingPlanChange(productFormId, sellingPlanId) {
    if (this.productFormId && this.productFormId === productFormId) {
      cartDebug(
        "QuickAdd onSellingPlanChange",
        productFormId,
        this.productFormId,
        sellingPlanId
      );
      this.sellingPlanId = sellingPlanId;
      this.showPriceForSellingPlan(sellingPlanId);
      this.quantityInCart = await cartDataFncs.getVariantQuantitySellingPlanInCart(
        this.variantId,
        this.sellingPlanId
      );
      this.updateElements();
    }
  }
  updateElements = async () => {
    if (this.button && this.buttonLabel) {
      let buttonAction = this.addItem;
      if (this.isFreeSample) {
        this.buttonLabel.innerHTML = this.labelAdd;
        buttonAction = this.addItem;
        this.button.disabled = false;
        this.button.classList.remove(this.itemInCartClass);
        if (this.freeSampleCartCount > 0) {
          if (this.itemCartKey) {
            this.buttonLabel.innerHTML = this.labelRemove;
            buttonAction = this.removeItem;
            this.button.classList.add(this.itemInCartClass);
          } else if (this.freeSampleCartCount >= this.freeSampleMax) {
            this.button.disabled = true;
          }
        }
      } else {
        if (this.quantityInCart >= this.maxQuantity) {
          this.buttonLabel.innerHTML = this.labelMax;
          this.button.disabled = true;
        } else {
          this.buttonLabel.innerHTML = this.labelAdd;
          this.button.disabled = false;
          this.showPriceForSellingPlan(this.sellingPlanId);
        }
      }
      this.addEventListeners(buttonAction);
    }
  };
  disableSiblingElements = () => {
    const siblingEls = document.querySelectorAll(
      `${this.groupSelector} ${DATA_IDENTIFIER} button`
    );
    siblingEls.forEach((el) => {
      if (el !== this) {
        el.classList.add("pointer-events-none");
        el.disabled = true;
      }
    });
  };
  showLoadingUI() {
    if (this.isFreeSample) {
      this.disableSiblingElements();
    }
    if (this.button) {
      this.button.classList.add("pointer-events-none");
      this.button.disabled = true;
    }
    const loadingSpinner = this.querySelector(".loading__spinner");
    loadingSpinner?.classList.remove("hidden");
  }
  hideLoadingUI() {
    if (this.button) {
      this.button.classList.remove("pointer-events-none");
      this.button.disabled = false;
    }
    const loadingSpinner = this.querySelector(".loading__spinner");
    loadingSpinner?.classList.add("hidden");
  }
  countFreeSamples(items) {
    return items.filter((item) => {
      return item.properties[PRODUCT_PROPERTY_KEYS.freeSample];
    }).length;
  }
  isThisItemInCart(items) {
    return items.some((item) => {
      return item.variant_id === this.variantId;
    });
  }
  getItemCartKey = (items) => {
    let item = items.find((item2) => {
      return item2.variant_id === this.variantId;
    });
    return item ? item.key : null;
  };
  getItemCartIndex = (items) => {
    return items.findIndex((item) => {
      return item.variant_id === this.variantId;
    });
  };
  onCartUpdate = async (cartData) => {
    this.quantityInCart = await cartDataFncs.getVariantQuantitySellingPlanInCart(
      this.variantId,
      this.sellingPlanId,
      cartData
    );
    this.freeSampleCartCount = this.countFreeSamples(cartData.cartRaw.items);
    this.itemCartKey = this.getItemCartKey(cartData.cartRaw.items);
    this.hideLoadingUI();
    this.updateElements();
  };
  addEventListeners(buttonAction) {
    this.removeEventListeners();
    this.buttonAction = buttonAction;
    this.button?.addEventListener("click", this.buttonAction);
  }
  removeEventListeners() {
    this.button?.removeEventListener("click", this.buttonAction);
  }
  removeItem = (event) => {
    event.preventDefault();
    this.showLoadingUI();
    cartChange({
      id: this.itemCartKey,
      quantity: 0
    });
  };
  addItem = (event) => {
    event.preventDefault();
    this.showLoadingUI();
    const variantArray = [
      {
        id: this.variantId,
        quantity: this.addQuantity,
        selling_plan: this.sellingPlanId,
        // https://shopify.dev/docs/api/ajax/reference/cart#private-properties-and-attributes
        properties: {
          ...this.isFreeSample ? { [PRODUCT_PROPERTY_KEYS.freeSample]: true } : {},
          [PRODUCT_PROPERTY_KEYS.size]: this.size,
          [PRODUCT_PROPERTY_KEYS.isSubscription]: this.sellingPlanId ? true : false
        }
        // ...(this.size ? { [PRODUCT_PROPERTY_KEYS.size]: this.size } : {}),
        // ...(this.sellingPlanId ? { [PRODUCT_PROPERTY_KEYS.isSubscription]: true } : {}),
      }
    ];
    cartAddItems(variantArray);
  };
};
customElements.define("quick-add", QuickAdd);

// src/js/customElements/cart-free-samples.js
var CartFreeSamples = class extends HTMLElement {
  constructor() {
    super();
    this.cartItemCount = parseInt(this.dataset["cartItemCount"] ?? "0");
    this.cartOriginalTotalPrice = parseInt(
      this.dataset["cartOriginalTotalPrice"] ?? "0"
    );
  }
  async connectedCallback() {
    this.updateElements(this.cartItemCount, this.cartOriginalTotalPrice);
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartMutationComplete,
      (payload) => {
        this.onCartUpdate(payload.cartData);
      },
      "quickAdd"
    );
  }
  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }
  onCartUpdate = (cartData) => {
    const { cartRaw } = cartData;
    const { item_count, original_total_price } = cartRaw;
    this.updateElements(item_count, original_total_price);
  };
  updateElements = async (cartItemCount, cartOriginalTotalPrice) => {
    if (cartItemCount > 0 && cartOriginalTotalPrice > 0) {
      this.classList.remove("hidden");
    } else {
      this.classList.add("hidden");
    }
  };
};
customElements.define("cart-free-samples", CartFreeSamples);

// src/js/customElements/visibility-detector.mjs
var DYNAMIC_YIELD_INTERSECTION_EVENT_NAME = "sectionIsVisible";
var VisibilityDetector = class extends HTMLElement {
  constructor() {
    super();
    this.dyEventName = DYNAMIC_YIELD_INTERSECTION_EVENT_NAME;
    this.visibilityDetectorId = this.dataset["visibilityDetectorId"] ?? null;
    this.triggeringSectionName = this.dataset["triggeringSectionName"] ?? null;
    this.triggeringSectionId = this.dataset["triggeringSectionId"] ?? null;
    this.doFireDyEvent = this.dataset["fireDyVisibilityEvent"] ? true : false;
    this.intersectionObsMinRatio = parseInt(
      this.dataset["intersectionObsMinRatio"] ?? "0"
    );
    this.intersectionObsTopMargin = parseInt(
      this.dataset["intersectionObsTopMargin"] ?? "0"
    );
    this.intersectionObserver = null;
  }
  fireDYEvent({ eventName = "", eventProps = {} }) {
    var eventPayload = {
      name: eventName,
      properties: eventProps
    };
    try {
      window.DY?.API("event", eventPayload);
    } catch (err) {
      console.error(err);
    }
  }
  fireDYEventOnIntersection() {
    const eventProps = {
      visibilityDetectorId: this.visibilityDetectorId,
      sectionName: this.triggeringSectionName,
      sectionId: this.triggeringSectionId
    };
    this.fireDYEvent({
      eventName: this.dyEventName,
      eventProps
    });
  }
  injectDummyElement() {
    let dummyEl = document.createElement("div");
    dummyEl.style.width = "1px";
    dummyEl.style.height = "1px";
    dummyEl.style.position = "absolute";
    dummyEl.style.top = "0";
    dummyEl.style.left = "0";
    dummyEl.style.pointerEvents = "none";
    dummyEl.style.opacity = "0.01";
    dummyEl.id = `${this.dyEventName}_${this.triggeringSectionName}`;
    this.visibilityDetectorId && dummyEl.setAttribute(
      "data-visibility-detector-id",
      this.visibilityDetectorId
    );
    this.triggeringSectionName && dummyEl.setAttribute(
      "data-triggering-section-name",
      this.triggeringSectionName
    );
    this.triggeringSectionId && dummyEl.setAttribute(
      "data-triggering-section-id",
      this.triggeringSectionId
    );
    this.appendChild(dummyEl);
  }
  monitorIntersection({
    targetNode = this,
    callbackIntersectionChange = (...args) => {
    },
    threshold = this.intersectionObsMinRatio,
    root = null,
    rootMargin = `0px 0px ${this.intersectionObsTopMargin}px 0px`
  }) {
    let options = {
      root,
      rootMargin,
      threshold
    };
    let intersectionCallback = (entries, observer) => {
      entries.forEach((entry) => {
        let { isIntersecting, intersectionRatio } = entry;
        callbackIntersectionChange({ isIntersecting, intersectionRatio });
        if (entry.isIntersecting) {
          observer.disconnect();
        }
      });
    };
    this.intersectionObserver = new IntersectionObserver(
      intersectionCallback,
      options
    );
    this.intersectionObserver?.observe(targetNode);
  }
  connectedCallback() {
    this.monitorIntersection({
      targetNode: this,
      callbackIntersectionChange: ({ isIntersecting, intersectionRatio }) => {
        if (isIntersecting) {
          this.injectDummyElement();
          if (this.doFireDyEvent) {
            this.fireDYEventOnIntersection();
          }
        }
      }
    });
  }
  disconnectedCallback() {
    this.intersectionObserver?.disconnect();
  }
};
customElements.define("visibility-detector", VisibilityDetector);

// src/js/customElements/yotpo-star-widget.js
var LOCAL_STORAGE_KEY_YOTPO_STAR_WIDGET_ANSWERED_QUESTIONS = "muradYotpoStarWidgetAnsweredQuestions";
var YOTPO_STAR_WIDGET_ANSWERED_QUESTIONS_STALE_AFTER_MS = 1e3 * 60 * 60;
var DEBOUNCE_MS_YOTPO_QA_DATA = 300;
function getCachedAnsweredQuestions(productId) {
  const localStorageCachedVal = getLocalStorage(
    LOCAL_STORAGE_KEY_YOTPO_STAR_WIDGET_ANSWERED_QUESTIONS
  );
  if (!localStorageCachedVal) {
    return null;
  }
  const answeredQuestionsThisProduct = localStorageCachedVal[productId];
  if (answeredQuestionsThisProduct) {
    const dataIsStale = hasTimeElapsed(
      answeredQuestionsThisProduct.lastUpdated,
      YOTPO_STAR_WIDGET_ANSWERED_QUESTIONS_STALE_AFTER_MS
    );
    if (!dataIsStale) {
      return answeredQuestionsThisProduct.answeredQuestionCount;
    }
  }
  return null;
}
function setCachedAnsweredQuestions(productId, answeredQuestions = 0) {
  const localStorageCachedVal = getLocalStorage(
    LOCAL_STORAGE_KEY_YOTPO_STAR_WIDGET_ANSWERED_QUESTIONS
  );
  setLocalStorage(LOCAL_STORAGE_KEY_YOTPO_STAR_WIDGET_ANSWERED_QUESTIONS, {
    ...localStorageCachedVal,
    [productId]: {
      answeredQuestionCount: answeredQuestions,
      lastUpdated: (/* @__PURE__ */ new Date()).toISOString()
    }
  });
}
async function getYotpoQAData(yotpoAppKey, productId) {
  try {
    const cachedAnsweredQuestionsThisProduct = getCachedAnsweredQuestions(productId);
    if (cachedAnsweredQuestionsThisProduct) {
      publish(PUB_SUB_EVENTS.yotpoQADataComplete, {
        answeredQuestionCount: cachedAnsweredQuestionsThisProduct
      });
      return;
    }
    if (!yotpoAppKey || !productId) {
      throw new Error("yotpo-star-widget: missing Yotpo App Key or Product ID");
    }
    const res = await fetch(
      `https://api.yotpo.com/products/${yotpoAppKey}/${productId}/qna_bottomline`
    );
    const json = await res.json();
    const answeredQuestionCount = json.response.total_answers;
    setCachedAnsweredQuestions(productId, answeredQuestionCount);
    publish(PUB_SUB_EVENTS.yotpoQADataComplete, { answeredQuestionCount });
  } catch (err) {
    console.error("getYotpoQAData", err);
  }
}
var debounceGetYotpoQAData = debounce(({ yotpoAppKey, productId }) => {
  getYotpoQAData(yotpoAppKey, productId);
}, DEBOUNCE_MS_YOTPO_QA_DATA);
subscribe(
  PUB_SUB_EVENTS.yotpoQADataRequest,
  debounceGetYotpoQAData,
  "yotpo-star-widget"
);
var YotpoStarWidget = class extends HTMLElement {
  constructor() {
    super();
    this.yotpoAppKey = this.dataset["yotpoAppKey"] ?? "";
    this.productId = this.dataset["productId"] ?? "";
    this.answeredQuestionsLabel = this.dataset["answeredQuestionsLabel"] ?? "";
    this.metafieldStarRating = parseInt(
      this.dataset["metafieldStarRating"] ?? "0"
    );
    this.hideYotpo = this.dataset["hideYotpo"] ? true : false;
    this.widgetObserver = null;
    this.reviewsQuestionsWasHandled = false;
    this.summaryWasHandled = false;
    this.unsubscriberReviewSummary = null;
    this.unsubscriberQAData = null;
  }
  doShowWidget(totalAnsweredQuestions = 0) {
    const hasQuestions = totalAnsweredQuestions > 0;
    const hasReviews = this.metafieldStarRating > 0;
    const hideYotpo = this.hideYotpo;
    if ((hasQuestions || hasReviews) && !hideYotpo) {
      return true;
    }
    return false;
  }
  createOnClickHandler(yotpoReviewsQATabIndex = 0) {
    return (e) => {
      const yotpoSection = document.querySelector(
        ".yotpo-widget-instance .yotpo-reviews-main-widget"
      );
      if (yotpoSection) {
        window.scrollTo({
          behavior: "smooth",
          top: yotpoSection.getBoundingClientRect().top + window.scrollY - 135
        });
        document.querySelectorAll(".ugc-storefront-widgets-tabs-container__tab")?.[yotpoReviewsQATabIndex]?.click();
      }
    };
  }
  modifyReviewsButton(reviewsButtonEl) {
    reviewsButtonEl?.addEventListener("click", this.createOnClickHandler(0));
  }
  addQAButton(totalAnsweredQuestions = 0) {
    const qaInsert = this.querySelector("[data-qa-insert]");
    if (!qaInsert || totalAnsweredQuestions === 0) {
      return;
    }
    const qaButton = qaInsert.querySelector("button");
    if (qaButton) {
      qaButton.addEventListener("click", this.createOnClickHandler(1));
      qaButton.textContent = `${totalAnsweredQuestions} ${this.answeredQuestionsLabel}`;
      qaInsert.classList.remove("hidden");
      qaInsert.classList.add("flex");
    }
  }
  cloneReviewsSummary() {
    const otherReviewsSummary = document.querySelector(
      "div.yotpo-star-rating-reviews-summary-link"
    );
    if (otherReviewsSummary) {
      const clonedReviewsSummary = otherReviewsSummary.cloneNode(true);
      const otherReviewsSummaryClickable = otherReviewsSummary.querySelector(
        "span.yotpo-star-rating-reviews-summary-text"
      );
      clonedReviewsSummary.addEventListener("click", (evt) => {
        evt.preventDefault();
        otherReviewsSummaryClickable?.click();
      });
      const reviewsSummaryParent = this.querySelector(
        "div.yotpo-reviews-star-ratings-widget > div"
      );
      reviewsSummaryParent?.appendChild(clonedReviewsSummary);
      return true;
    }
    return false;
  }
  doesHaveReviewSummary() {
    const thisReviewsSummary = this.querySelector(
      "div.yotpo-star-rating-reviews-summary-link"
    );
    if (thisReviewsSummary) {
      return true;
    }
    return false;
  }
  prepReviewsSummary() {
    if (this.doesHaveReviewSummary()) {
      return true;
    } else {
      return this.cloneReviewsSummary();
    }
  }
  async mutationCallback(mutationRecordArray, observer) {
    const yotpoStarWidgetInjectedBlock = this.querySelector(
      "#yotpo-reviews-star-ratings-widget"
    );
    if (!yotpoStarWidgetInjectedBlock) {
      return;
    }
    if (!this.reviewsQuestionsWasHandled) {
      this.reviewsQuestionsWasHandled = true;
      publish(PUB_SUB_EVENTS.yotpoQADataRequest, {
        yotpoAppKey: this.yotpoAppKey,
        productId: this.productId
      });
    }
    if (!this.summaryWasHandled) {
      const hasReviewSummary = this.doesHaveReviewSummary();
      if (hasReviewSummary) {
        this.summaryWasHandled = hasReviewSummary;
        publish(PUB_SUB_EVENTS.yotpoReviewSummaryLoaded, { node: this });
        observer.disconnect();
      }
    }
  }
  watchForYotpoWidget() {
    const observerTargetNode = this;
    const observerOptions = {
      subtree: true,
      childList: true
    };
    this.widgetObserver = new MutationObserver(
      // note: arrow fnc required to preserve "this"
      (mutationRecordArray, observer) => this.mutationCallback(mutationRecordArray, observer)
    );
    this.widgetObserver.observe(observerTargetNode, observerOptions);
  }
  // overrideStyles() {
  //   this.querySelectorAll("svg").forEach((el) => {
  //     el.setAttribute("height", "10px");
  //     el.setAttribute("width", "10px");
  //     el.style.marginTop = "-1px";
  //     const path = el.querySelector("path");
  //     if (path) {
  //       path.style.fill = "var(--color-gray-dark)";
  //       path.style.stroke = "var(--color-gray-dark)";
  //     }
  //   });
  //   this.querySelectorAll("*").forEach((el) => {
  //     el.style.fontSize = "10px";
  //     el.style.lineHeight = "10px";
  //   });
  //   const bottomLineSummary = this.querySelector(
  //     ".yotpo-sr-bottom-line-summary",
  //   );
  //   if (bottomLineSummary && bottomLineSummary.firstElementChild) {
  //     bottomLineSummary.firstElementChild.style.marginRight = "5px";
  //   }
  // }
  onYotpoReviewSummaryLoaded(node) {
    this.prepReviewsSummary();
  }
  onYotpoQADataComplete(answeredQuestionCount) {
    if (this.doShowWidget(answeredQuestionCount)) {
      this.modifyReviewsButton(
        this.querySelector("button.yotpo-sr-bottom-line-button")
      );
      this.addQAButton(answeredQuestionCount);
      this.classList.remove("hidden");
      this.classList.add("flex");
    }
  }
  connectedCallback() {
    this.unsubscriberReviewSummary = subscribe(
      PUB_SUB_EVENTS.yotpoReviewSummaryLoaded,
      ({ node }) => {
        this.onYotpoReviewSummaryLoaded(node);
      },
      "yotpo-star-widget"
    );
    this.unsubscriberQAData = subscribe(
      PUB_SUB_EVENTS.yotpoQADataComplete,
      ({ answeredQuestionCount }) => {
        this.onYotpoQADataComplete(answeredQuestionCount);
      },
      "yotpo-star-widget"
    );
    this.watchForYotpoWidget();
  }
  disconnectedCallback() {
    if (this.unsubscriberReviewSummary) {
      this.unsubscriberReviewSummary();
    }
    if (this.unsubscriberQAData) {
      this.unsubscriberQAData();
    }
    if (this.widgetObserver) {
      this.widgetObserver.disconnect();
    }
  }
};
customElements.define("yotpo-star-widget", YotpoStarWidget);

// src/js/customElements/complementary-regimen.js
var API_URL_PATH_COMPLEMENTARY_REGIMEN = `/api/recommendations/completeRegimen`;
var LOCAL_STORAGE_KEY_REGIMEN_MAP = "muradComplementaryRegimen_regimenMap";
var LOCAL_STORAGE_KEY_PRODUCT_MAP = "muradComplementaryRegimen_productMap";
var REGIMEN_DATA_STALE_AFTER = 1e3 * 60 * 60 * 1;
var DEFAULT_CATEGORIES = [
  "cleanser",
  "treatment",
  "moisturizer",
  "exfoliantPeel"
];
var CATEGORY_LABELS = {
  cleanser: "Cleanse",
  treatment: "Treat",
  eyeTreatment: "Treat",
  moisturizer: "Hydrate",
  exfoliantPeel: "Nourish"
};
var CATEGORY_DESCRIPTIONS = {
  cleanser: "Remove buildup and prep skin to absorb what comes next",
  treatment: "Actives that work where skin needs them most",
  eyeTreatment: "Actives that work where skin needs them most",
  moisturizer: "Lock in moisture, strengthen, and support renewal",
  exfoliantPeel: "Targeted rituals that elevate your everyday routine"
};
var LABELS2 = {
  addComplete: "Add Complete Regimen to Bag *",
  addSome: "Add Regimen to Bag *",
  addOne: "Add to Bag *"
};
var ComplementaryRegimen = class extends HTMLElement {
  constructor() {
    super();
    this.section = this.querySelector(
      "section[data-complementary-regimen-main-section]"
    );
    this.sku = this.dataset["sku"];
    this.personalization_group_id = this.dataset["personalizationGroupId"];
    this.targetSku = this.personalization_group_id || this.sku;
    this.concernColor = this.dataset["concernColor"] || "#000000";
    this.mainProduct = {};
    this.complementaryRegimen = [{}];
    this.complementaryRegimenObj = {};
    this.categories = this.dataset["categories"] ? this.dataset["categories"].split(",").map((cat) => cat.trim()) : DEFAULT_CATEGORIES;
    this.loadingSpinnerTitle = this.querySelector(".loading_spinner_title");
    this.checkboxList = this.querySelectorAll("input[type='checkbox']");
    this.addToCartButton = this.querySelector(
      "button[data-complementary-regimen-atc-button]"
    );
    this.form = this.querySelector("[data-complementary-regimen-form]");
    this.featureImage = this.querySelector("[data-feature-image]");
    this.addToCartSection = this.querySelector(
      "[data-complementary-regimen-atc-section]"
    );
    this.atcLoadingSpinner = this.addToCartSection?.querySelector("loading__spinner");
    this.cartUpdateUnsubscriber = null;
    this.skinQuizDomain = this.dataset["skinQuizDomain"];
    console.log(
      "node env",
      "development",
      "skin quiz domain",
      this.skinQuizDomain
    );
    this.apiUrlComplementaryRegimen = `${this.skinQuizDomain}${API_URL_PATH_COMPLEMENTARY_REGIMEN}`;
    this.intersectionObserver = null;
    this.strings = {
      addComplete: this.dataset["labelAddComplete"] ?? LABELS2.addComplete,
      addSome: this.dataset["labelAddSome"] ?? LABELS2.addSome,
      addOne: this.dataset["labelAddOne"] ?? LABELS2.addOne,
      regimenCompleteATC: this.dataset["labelRegimenComplete"] ?? "Your regimen is complete",
      regimenCompletePrice: this.dataset["labelRegimenCompletePrice"] ?? // "Enjoy your complete regimen!",
      "",
      selectItemsToAdd: this.dataset["labelSelectItemsToAdd"] ?? "Select items to add"
    };
  }
  updateAddToCartButtonState(selectedProducts) {
    const completeRegimenIsInCart = this.complementaryRegimen.every(
      (product) => product.quantityInCart > 0
    );
    const someRegimenIsInCart = this.complementaryRegimen.some(
      (product) => product.quantityInCart > 0
    );
    if (this.addToCartButton) {
      if (selectedProducts.length === 0 || completeRegimenIsInCart) {
        this.disableATCButton();
      } else {
        this.enableATCButton();
      }
      const buttonLabel = this.addToCartButton.querySelector(
        "[data-button-label]"
      );
      if (buttonLabel) {
        if (completeRegimenIsInCart) {
          buttonLabel.textContent = `Your regimen is complete`;
        } else if (selectedProducts.length > 0) {
          buttonLabel.textContent = `Add ${selectedProducts.length === this.categories.length ? "ALL" : ""} ${selectedProducts.length === 2 ? "both" : selectedProducts.length} TO BAG`;
        } else {
          buttonLabel.textContent = "Select items to add";
        }
      }
    }
  }
  updateTotalPrice(selectedProducts) {
    const totalPrice = selectedProducts.reduce((sum, product) => {
      return sum + (product.price || 0);
    }, 0);
    const completeRegimenIsInCart = this.complementaryRegimen.every(
      (product) => product.quantityInCart > 0
    );
    const elPriceLabel = this.querySelector("[data-total-price-label]");
    const elPriceValue = this.querySelector("[data-total-price-value]");
    if (elPriceLabel && elPriceValue) {
      if (totalPrice > 0) {
        elPriceLabel.textContent = `Price for ${selectedProducts.length === this.categories.length ? "all" : ""} ${selectedProducts.length}: `;
        elPriceValue.textContent = totalPrice > 0 ? `$${totalPrice.toFixed(2)}` : "\xA0";
      } else if (completeRegimenIsInCart) {
        elPriceLabel.textContent = this.strings.regimenCompletePrice;
        elPriceValue.textContent = "\xA0";
      } else {
        elPriceLabel.textContent = "\xA0";
        elPriceValue.textContent = "\xA0";
      }
    }
  }
  createAddProductPayload(variantArray) {
    return variantArray.map((variant) => {
      const { id, size } = variant;
      const thisProduct = this.complementaryRegimenObj[variant.id];
      const { name, category } = thisProduct;
      return {
        id,
        quantity: 1,
        selling_plan: null,
        // https://shopify.dev/docs/api/ajax/reference/cart#private-properties-and-attributes
        properties: {
          [PRODUCT_PROPERTY_KEYS.size]: size,
          [PRODUCT_PROPERTY_KEYS.cartMessage]: `[*Your Complete Regimen:*] [**${CATEGORY_LABELS[category] ?? category}**]`,
          [PRODUCT_PROPERTY_KEYS.cartMessageColor]: `${this.concernColor}`
        }
      };
    });
  }
  getSelectedProducts() {
    const selectedProducts = [];
    this.checkboxList.forEach((checkbox) => {
      if (checkbox.checked && checkbox.dataset.variantId) {
        selectedProducts.push({
          id: parseInt(checkbox.dataset.variantId),
          size: checkbox.dataset.size,
          price: parseFloat(checkbox.dataset.price)
        });
      }
    });
    return selectedProducts;
  }
  updateProductTiles() {
    const regimen = this.complementaryRegimen;
    const productTiles = this.querySelectorAll(
      ".complementary_regimen__product_tile"
    );
    productTiles.forEach((tile, i) => {
      const category = tile.dataset["category"];
      const productData = regimen[i];
      if (productData) {
        tile.dataset.variantId = productData.variantId || "";
        const checkbox = tile.querySelector("input[type='checkbox']");
        const elInCartMessageWrapper = tile.querySelector(
          ".product_in_cart_message_wrapper"
        );
        const elInCartMessage = tile.querySelector(".product_in_cart_message");
        const elProductDetailsWrapper = tile.querySelector(
          ".product_details_wrapper"
        );
        const elProductTileLabel = tile.querySelector("label");
        const elListHidenWhenInCart = tile.querySelectorAll(
          ".hide_when_product_in_cart"
        );
        if (elInCartMessageWrapper && elInCartMessage && elProductDetailsWrapper) {
          if (productData.quantityInCart > 0) {
            elInCartMessageWrapper.classList.remove("hidden");
            elProductDetailsWrapper.classList.add("opacity-50");
            elListHidenWhenInCart.forEach((el) => el.classList.add("hidden"));
          } else {
            elInCartMessageWrapper.classList.add("hidden");
            elProductDetailsWrapper.classList.remove("opacity-50");
            elListHidenWhenInCart.forEach(
              (el) => el.classList.remove("hidden")
            );
          }
        }
        if (checkbox) {
          checkbox.dataset.variantId = productData.variantId;
          checkbox.dataset.size = productData.size;
          checkbox.dataset.price = productData.price;
          if (this.targetSku === productData.sku && productData.quantityInCart === 0) {
            checkbox.disabled = true;
            checkbox.classList.add("hidden");
            checkbox.checked = true;
          } else if (productData.quantityInCart > 0) {
            checkbox.disabled = true;
            checkbox.classList.add("hidden");
            checkbox.checked = false;
          } else {
            checkbox.disabled = false;
            checkbox.classList.remove("hidden");
            checkbox.checked = true;
          }
        }
        for (const key in productData) {
          const thisTileElement = tile.querySelector(`.product_${key}`);
          if (thisTileElement) {
            switch (key) {
              case "category":
                thisTileElement.textContent = CATEGORY_LABELS[productData[key]] || productData[key];
                break;
              case "price":
                thisTileElement.textContent = `$${productData[key].toFixed(2)}`;
                break;
              case "imgUrl":
                thisTileElement.src = productData[key];
                thisTileElement.classList.remove("hidden");
                break;
              case "pdpUrl":
                thisTileElement.href = productData[key];
                break;
              case "desc":
                thisTileElement.textContent = CATEGORY_DESCRIPTIONS[productData["category"]] || productData["desc"] || "";
                break;
              default:
                thisTileElement.textContent = productData[key];
            }
          }
        }
        const thisItemPreface = tile.querySelector(
          ".product_name_this_item_preface"
        );
        if (thisItemPreface && productData.sku === this.targetSku) {
          thisItemPreface.classList.remove("hidden");
        }
        const inCartPreface = tile.querySelector(".product_in_cart");
        if (inCartPreface) {
          if (productData.quantityInCart > 0) {
            inCartPreface.classList.remove("hidden");
            const inCartCount = inCartPreface.querySelector(
              ".product_in_cart_count"
            );
            if (inCartCount) {
              inCartCount.textContent = productData.quantityInCart;
            }
          } else {
            inCartPreface.classList.add("hidden");
          }
        }
      } else {
        tile.style.display = "none";
      }
    });
  }
  getCachedRegimenSkus(targetSku, categories) {
    const cachedRegimen = getLocalStorage(LOCAL_STORAGE_KEY_REGIMEN_MAP);
    if (cachedRegimen) {
      const categoriesSortedString = [...categories].sort().join(",");
      const targetRegimen = cachedRegimen[targetSku]?.[categoriesSortedString];
      if (targetRegimen) {
        const { regimenSkus, lastModified } = targetRegimen;
        const regimenDataIsStale = hasTimeElapsed(
          lastModified,
          REGIMEN_DATA_STALE_AFTER
        );
        if (!regimenDataIsStale) {
          console.log("CACHED regimen");
          return regimenSkus;
        }
      }
    }
    return null;
  }
  getCachedRegimenProducts(regimenSkus = []) {
    const cachedProductList = getLocalStorage(LOCAL_STORAGE_KEY_PRODUCT_MAP);
    if (regimenSkus && cachedProductList) {
      const productList = regimenSkus.map((sku) => cachedProductList[sku]);
      if (productList.every((product) => product !== void 0)) {
        console.log("CACHED product list");
        return productList;
      }
    }
    return null;
  }
  cacheRegimen(targetSku = "", categories = DEFAULT_CATEGORIES, regimenSkus = []) {
    const lastModified = (/* @__PURE__ */ new Date()).toISOString();
    const cacheEntry = { regimenSkus, lastModified };
    const cachedRegimen = getLocalStorage(LOCAL_STORAGE_KEY_REGIMEN_MAP) || {};
    if (!cachedRegimen[targetSku]) {
      cachedRegimen[targetSku] = {};
    }
    const categoriesSortedString = [...categories].sort().join(",");
    cachedRegimen[targetSku][categoriesSortedString] = cacheEntry;
    setLocalStorage(LOCAL_STORAGE_KEY_REGIMEN_MAP, cachedRegimen);
  }
  cacheProductData(productList = []) {
    const cachedProductList = getLocalStorage(LOCAL_STORAGE_KEY_PRODUCT_MAP) || {};
    productList.forEach((product) => {
      cachedProductList[product.sku] = product;
    });
    setLocalStorage(LOCAL_STORAGE_KEY_PRODUCT_MAP, cachedProductList);
  }
  async getComplementaryRegimen(sku = "", categories = DEFAULT_CATEGORIES) {
    if (!this.skinQuizDomain) {
      throw new Error("No skin quiz domain provided");
    }
    const payload = {
      sku,
      categories
    };
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      // mode: "cors",
      body: JSON.stringify(payload)
    };
    try {
      const res = await fetch(
        `${this.skinQuizDomain}${API_URL_PATH_COMPLEMENTARY_REGIMEN}`,
        options
      );
      const json = await res.json();
      if (res.ok) {
        return json;
      } else if (json.message) {
        throw new Error(json.message);
      } else {
        throw new Error(
          `Error retrieving recommendations: ${res.status} - ${res.statusText}`
        );
      }
    } catch (err) {
      throw err;
    }
  }
  async handleRegimenData() {
    let complementaryRegimen = [];
    const cachedRegimenSkus = this.getCachedRegimenSkus(
      this.targetSku,
      this.categories
    );
    const cachedRegimenProducts = this.getCachedRegimenProducts(cachedRegimenSkus);
    if (cachedRegimenSkus && cachedRegimenProducts) {
      complementaryRegimen = cachedRegimenProducts;
    } else {
      const res = await this.getComplementaryRegimen(
        this.targetSku,
        this.categories
      );
      if (!res.data || !res.data.regimenSkus || !res.data.productList) {
        throw new Error("Invalid regimen data from server");
      }
      const { regimenSkus, productList } = res.data;
      this.cacheRegimen(this.targetSku, this.categories, regimenSkus);
      this.cacheProductData(productList);
      complementaryRegimen = productList;
    }
    this.complementaryRegimen = complementaryRegimen;
    this.complementaryRegimenObj = complementaryRegimen.reduce((prev, curr) => {
      return {
        ...prev,
        [curr.variantId]: curr
      };
    }, {});
    return complementaryRegimen;
  }
  updateATC() {
    const selectedProducts = this.getSelectedProducts();
    this.updateTotalPrice(selectedProducts);
    this.updateAddToCartButtonState(selectedProducts);
  }
  disableATCButton() {
    if (this.addToCartButton) {
      this.addToCartButton.disabled = true;
      this.addToCartButton.classList.add("pointer-events-none");
      this.addToCartButton.classList.add("opacity-50");
    }
  }
  enableATCButton() {
    if (this.addToCartButton) {
      this.addToCartButton.classList.remove("pointer-events-none");
      this.addToCartButton.classList.remove("opacity-50");
      this.addToCartButton.disabled = false;
    }
  }
  showLoadingUI() {
    this.disableATCButton();
    this.atcLoadingSpinner?.classList.remove("hidden");
  }
  hideLoadingUI() {
    this.enableATCButton();
    this.atcLoadingSpinner?.classList.add("hidden");
  }
  addItemsToCart() {
    this.showLoadingUI();
    const selectedProducts = this.getSelectedProducts();
    const variantArray = this.createAddProductPayload(selectedProducts);
    cartAddItems(variantArray);
  }
  addEventListeners() {
    this.checkboxList.forEach((checkbox) => {
      checkbox.addEventListener("change", this.updateATC.bind(this));
    });
    this.addToCartButton?.addEventListener(
      "click",
      this.addItemsToCart.bind(this)
    );
  }
  async updateQuantitiesInCart(cartData = null) {
    const variantQuantities = await cartDataFncs.getVariantQuantityInCart(
      this.complementaryRegimen.map((product) => product.variantId),
      cartData
    );
    this.complementaryRegimen = this.complementaryRegimen.map((product, i) => ({
      ...product,
      quantityInCart: variantQuantities[i]
    }));
  }
  async onCartUpdate(cartData) {
    this.hideLoadingUI();
    cartDebug("complementary-regimen onCartUpdate", cartData);
    await this.updateQuantitiesInCart(cartData);
    this.updateProductTiles();
    this.updateATC();
  }
  hideElListIfThisIntersecting(elListToHideSelectors = []) {
    const elToObserve = this;
    const getElListToHide = () => elListToHideSelectors.map((selector) => document.querySelector(selector)).filter((el) => el !== null);
    const prepElsToHide = () => {
      elListToHide.forEach((el) => el.classList.add("transition-opacity"));
    };
    let elListToHide = getElListToHide();
    prepElsToHide();
    if (elListToHideSelectors.length > 0 && elToObserve) {
      this.intersectionObserver = new IntersectionObserver(
        ([entry]) => {
          if (elListToHide.length < elListToHideSelectors.length) {
            elListToHide = getElListToHide();
            prepElsToHide();
          }
          if (entry.intersectionRatio >= 0.5 && window.innerWidth < 1024) {
            elListToHide.forEach((el) => el.classList.add("opacity-0"));
            elListToHide.forEach(
              (el) => setTimeout(() => el.classList.add("visually-hidden"), 150)
            );
          } else {
            elListToHide.forEach((el) => el.classList.remove("opacity-0"));
            elListToHide.forEach(
              (el) => setTimeout(() => el.classList.remove("visually-hidden"), 150)
            );
          }
        },
        { threshold: 0.5 }
      );
      this.intersectionObserver.observe(elToObserve);
    }
  }
  reduceTheNoise() {
    const elListToHideSelectors = [
      "[data-sticky-cta-mobile]",
      "#fw-player",
      "#reamazejs-container",
      "#attentive_overlay"
    ];
    this.hideElListIfThisIntersecting(elListToHideSelectors);
  }
  async connectedCallback() {
    this.reduceTheNoise();
    try {
      const complementaryRegimen = await this.handleRegimenData();
      this.mainProduct = complementaryRegimen.find(
        (product) => product.sku === this.targetSku
      );
      await this.updateQuantitiesInCart();
      this.updateProductTiles();
      if (this.form) {
        this.form.classList.remove("hidden");
      }
      if (this.featureImage) {
        this.featureImage.classList.remove("hidden");
      }
      this.updateATC();
      this.addEventListeners();
      this.cartUpdateUnsubscriber = subscribe(
        PUB_SUB_EVENTS.cartMutationComplete,
        async (payload) => {
          await this.onCartUpdate(payload.cartData);
        },
        "complementary-regimen"
      );
    } catch (err) {
      this.section?.style.setProperty("min-height", "unset");
      this.style.display = "none";
      console.error(err);
    } finally {
      this.loadingSpinnerTitle?.classList.add("hidden");
    }
  }
  disconnectedCallback() {
    this.checkboxList.forEach((checkbox) => {
      checkbox.removeEventListener("change", this.updateATC.bind(this));
    });
    this.addToCartButton?.removeEventListener(
      "click",
      this.addItemsToCart.bind(this)
    );
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
    }
  }
};
customElements.define("complementary-regimen", ComplementaryRegimen);

// src/js/cart/cartRules.js
var CART_RULES_CONFIG = {
  // Rule 1 — max qty per paid line item
  RULE_1_ENABLED: true,
  RULE_1_CAP: CART_LINE_ITEM_QUANTITY_MAX_DEFAULT,
  // 6
  // Rule 2 — max qty per zero-dollar line item
  RULE_2_ENABLED: true,
  RULE_2_CAP: 1,
  // Rule 3 — no duplicate zero-dollar variant across line items
  RULE_3_ENABLED: true,
  // Rule 4 — max total zero-dollar qty across cart
  RULE_4_ENABLED: true,
  RULE_4_CAP: 10,
  // Rule 5 — zero-dollar-only cart is cleared
  RULE_5_ENABLED: true
};
function isRuleEnabled(configDefault, lsKey) {
  if (localStorage.getItem("muradCartRules") === "0")
    return false;
  const override = localStorage.getItem(lsKey);
  if (override === "0")
    return false;
  return configDefault;
}
function isZeroDollarItem(item) {
  return item.original_price === 0;
}
function enforceCartRules(cartData) {
  const items = cartData?.cartRaw?.items ?? [];
  if (items.length === 0)
    return [];
  const messages = [];
  if (isRuleEnabled(CART_RULES_CONFIG.RULE_5_ENABLED, "muradCartRulesRule5") && cartData.cartTotalPrice === 0) {
    cartDebug("enforceCartRules rule 5: clearing zero-dollar-only cart");
    messages.push(
      "Your cart contained only free items and has been cleared."
    );
    publish(PUB_SUB_EVENTS.cartClearRequest);
    return messages;
  }
  const updates = {};
  const zeroDollarVariantsSeen = /* @__PURE__ */ new Set();
  let zeroDollarRunningTotal = 0;
  for (const item of items) {
    const variantId = item.variant_id;
    if (isZeroDollarItem(item)) {
      if (isRuleEnabled(CART_RULES_CONFIG.RULE_3_ENABLED, "muradCartRulesRule3") && zeroDollarVariantsSeen.has(variantId)) {
        const keyToRemove = item.key;
        cartDebug(
          `enforceCartRules rule 3: duplicate zero-dollar variant ${variantId} ("${item.title}") \u2014 scheduling deferred removal of line item key ${keyToRemove}`
        );
        messages.push(
          `A duplicate free item ("${item.title}") was removed from your cart.`
        );
        setTimeout(() => {
          publish(
            PUB_SUB_EVENTS.cartChangeRequest,
            PUB_SUB_PAYLOADS[PUB_SUB_EVENTS.cartChangeRequest]({
              id: keyToRemove,
              quantity: 0
            })
          );
        }, 0);
        continue;
      }
      zeroDollarVariantsSeen.add(variantId);
      let correctedQty = isRuleEnabled(CART_RULES_CONFIG.RULE_2_ENABLED, "muradCartRulesRule2") ? Math.min(item.quantity, CART_RULES_CONFIG.RULE_2_CAP) : item.quantity;
      if (isRuleEnabled(CART_RULES_CONFIG.RULE_2_ENABLED, "muradCartRulesRule2") && correctedQty < item.quantity) {
        cartDebug(
          `enforceCartRules rule 2: capping zero-dollar item ${variantId} ("${item.title}") from ${item.quantity} to ${correctedQty}`
        );
        messages.push(
          `Free item quantity for "${item.title}" was reduced to ${correctedQty} (maximum ${CART_RULES_CONFIG.RULE_2_CAP} per free item).`
        );
      }
      if (isRuleEnabled(CART_RULES_CONFIG.RULE_4_ENABLED, "muradCartRulesRule4")) {
        const capacityRemaining = CART_RULES_CONFIG.RULE_4_CAP - zeroDollarRunningTotal;
        if (correctedQty > capacityRemaining) {
          cartDebug(
            `enforceCartRules rule 4: total zero-dollar qty limit reached; reducing "${item.title}" from ${correctedQty} to ${capacityRemaining}`
          );
          messages.push(
            `Your cart has reached the maximum of ${CART_RULES_CONFIG.RULE_4_CAP} free items. "${item.title}" quantity was adjusted.`
          );
          correctedQty = capacityRemaining;
        }
      }
      zeroDollarRunningTotal += correctedQty;
      if (correctedQty !== item.quantity) {
        updates[variantId] = correctedQty;
      }
    } else {
      if (isRuleEnabled(CART_RULES_CONFIG.RULE_1_ENABLED, "muradCartRulesRule1") && item.quantity > CART_RULES_CONFIG.RULE_1_CAP) {
        cartDebug(
          `enforceCartRules rule 1: capping paid item ${variantId} ("${item.title}") from ${item.quantity} to ${CART_RULES_CONFIG.RULE_1_CAP}`
        );
        messages.push(
          `"${item.title}" quantity was reduced to ${CART_RULES_CONFIG.RULE_1_CAP} (maximum per item).`
        );
        updates[variantId] = CART_RULES_CONFIG.RULE_1_CAP;
      }
    }
  }
  if (Object.keys(updates).length > 0) {
    cartDebug("enforceCartRules: publishing corrections", updates);
    publish(
      PUB_SUB_EVENTS.cartUpdateRequest,
      PUB_SUB_PAYLOADS[PUB_SUB_EVENTS.cartUpdateRequest]({
        variantQuantityMap: updates
      })
    );
  }
  if (messages.length > 0) {
    cartDebug("enforceCartRules violations found:", messages);
  }
  return messages;
}

// src/js/cart/cartHub.js
function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`
    }
  };
}
function getIsCartPage() {
  return window.location.pathname.includes("/cart");
}
function getSectionsToRender(isCartPage) {
  const cartDrawerComponents = [
    {
      section: "header",
      id: "cart-drawer-wrapper",
      // selector: "#cart-drawer-ajax",
      // selector: "[data-ajax-cart-content]",
      selector: ".cart-items-ajax"
    },
    {
      section: "header",
      id: "cart-drawer-wrapper",
      selector: "#cart-drawer-toggle-ajax"
    },
    {
      section: "header",
      id: "cart-drawer-wrapper",
      selector: ".cart-checkout-cta-ajax"
    },
    {
      section: "header",
      id: "cart-drawer-wrapper",
      selector: "#cart-drawer-title"
    },
    {
      section: "header",
      id: "cart-drawer-wrapper",
      selector: "#cart-drawer-checkout-cta"
    },
    {
      section: "header",
      id: "cart-drawer-wrapper",
      selector: "#cart-free-ship-drawer [data-remaining]"
    }
  ];
  const cartPageComponents = [
    {
      section: "cart-page",
      id: "cart-page",
      // section: document.getElementById("main-cart-items")?.dataset.id,
      selector: ".cart-items-ajax"
    },
    {
      section: "cart-page",
      id: "cart-page",
      selector: "#cart-title-mobile"
    },
    {
      section: "cart-page",
      id: "cart-page",
      selector: "#cart-title-desktop"
    },
    {
      section: "cart-page",
      id: "cart-page-footer",
      selector: ".cart-checkout-cta-ajax"
    },
    {
      section: "cart-page",
      id: "cart-page",
      selector: "#cart-page-yotpo-rewards-ajax .yotpo-points-anon"
    },
    {
      section: "cart-page",
      id: "cart-page",
      selector: "#cart-page-additional-checkout-buttons-ajax"
    },
    {
      section: "cart-page",
      id: "cart-page",
      selector: "#cart-free-ship-mobile [data-remaining]"
    },
    {
      section: "cart-page",
      id: "cart-page",
      selector: "#cart-free-ship-desktop [data-remaining]"
    }
    // note: don't attempt to use Shopify bundled section rendering to update carousels; as originally built, they will fail because JS behind the Splide component will not be retriggered by the re-render;
    // {
    //   id: "cart-page",
    //   section: "cart-page",
    //   selector: "#cart-page-free-samples-ajax",
    // },
  ];
  return [...cartDrawerComponents, ...isCartPage ? cartPageComponents : []];
}
function getSectionInnerHTML(html, selector) {
  return new DOMParser().parseFromString(html, "text/html").querySelector(selector)?.innerHTML;
}
function replaceSections(sectionsToRender, resSections) {
  sectionsToRender.forEach((section) => {
    const elementToReplace = document.getElementById(section.id)?.querySelector(section.selector);
    if (elementToReplace === null) {
      cartDebug(
        `Cannot find element to replace for section: ${section.section}; id: ${section.id}; selector: ${section.selector}.  This may be fine b/c some elements shouldn't be rendered (e.g. alternate rewards display if user is logged-in or anonymous)`
      );
      return;
    }
    const updatedSectionHTML = resSections[section.section];
    if (elementToReplace && updatedSectionHTML) {
      elementToReplace.innerHTML = getSectionInnerHTML(
        updatedSectionHTML,
        section.selector
      );
    } else {
      cartDebug(
        `Updated section HTML not found; cannot update ${section.section}; id: ${section.id}; selector: ${section.selector}`
      );
    }
  });
}
var fetchURLs = {
  // window.Shopify.routes.root + "cart/add.js
  // add: `${window.routes.cart_add_url}`,
  add: `/cart/add`,
  // change: `${window.routes.cart_change_url}`,
  // mutate one line item at a time;
  change: `/cart/change`,
  // mutate cart line item quantities
  update: `/cart/update`,
  clear: `/cart/clear`
};
function openCartDrawer() {
  const isCartPage = getIsCartPage();
  if (!isCartPage) {
    const cartDrawerToggle = document.querySelector("#cart-drawer-toggle");
    if (cartDrawerToggle) {
      cartDrawerToggle.checked = true;
    }
  }
}
subscribe(
  PUB_SUB_EVENTS.cartMutationComplete,
  openCartDrawer,
  "openCartDrawer"
);
function showCartRulesNotification(messages) {
  const NOTIFICATION_ID = "cart-rules-notification";
  const PARENT_ID = "cart-drawer-content";
  const DISMISS_AFTER_MS = 1e4;
  let el = document.getElementById(NOTIFICATION_ID);
  if (!el) {
    el = document.createElement("div");
    el.id = NOTIFICATION_ID;
    el.setAttribute("role", "status");
    el.style.cssText = [
      "position:absolute",
      "top:4.5rem",
      "left:50%",
      "transform:translateX(-50%)",
      //"z-index:9999",
      "max-width:28rem",
      "width:calc(100% - 2rem)",
      "min-height:5rem",
      "background:#fef3c7",
      "border:1px solid #f59e0b",
      "color:#92400e",
      "font-size:0.875rem",
      "border-radius:0.375rem",
      "padding:0.75rem 1rem",
      "box-shadow:0 4px 12px rgba(0,0,0,0.12)"
    ].join(";");
    document.getElementById(PARENT_ID)?.appendChild(el);
  }
  el.innerHTML = `<button onclick="this.closest('#${NOTIFICATION_ID}').hidden=true" aria-label="Dismiss" style="position:absolute;top:0;right:0;background:none;border:none;cursor:pointer;font-size:1.5rem;line-height:0.6;color:#92400e;padding:0.5rem">&times;</button>` + messages.map((msg) => `<p style="margin:0 0 0.25rem;padding-right:1.25rem">${msg}</p>`).join("");
  el.hidden = false;
  clearTimeout(el._dismissTimer);
  el._dismissTimer = setTimeout(() => {
    el.hidden = true;
  }, DISMISS_AFTER_MS);
}
async function mutateCartAndPublish({
  action,
  payload,
  line = void 0,
  id = void 0
}) {
  const isCartPage = getIsCartPage();
  try {
    publish(
      PUB_SUB_EVENTS.cartInFlight,
      PUB_SUB_PAYLOADS[PUB_SUB_EVENTS.cartInFlight]({
        isInFlight: true,
        id,
        line
      })
    );
    const sectionsToRender = getSectionsToRender(isCartPage);
    if (getCartDebugState() === true) {
      debugOutlineElements(
        sectionsToRender.map(
          (section) => document.getElementById(section.id)?.querySelector(section.selector)
        ),
        "red"
      );
    }
    const uniqueSectionArray = sectionsToRender.reduce((prev, curr) => {
      if (!prev.includes(curr.section)) {
        prev.push(curr.section);
      }
      return prev;
    }, []);
    cartDebug("cart fetch", action);
    const body = JSON.stringify({
      ...payload,
      sections: uniqueSectionArray
    });
    const res = await fetch(`${fetchURLs[action]}`, {
      ...fetchConfig(),
      ...{ body }
    });
    if (res.status === 200) {
      const resJson = await res.json();
      if (resJson.errors) {
        throw new Error(resJson.errors);
      }
      let cartData;
      if (action === "add") {
        cartData = await getCartData(true);
      } else {
        cartData = shapeCartData(resJson);
      }
      const { cartRaw, cartTotalPrice, cartItemVariantIds } = cartData;
      setCartDataLocalStorage(cartData);
      const { doAddGifts, doRemoveGifts } = addRemoveGwpItems(cartData);
      if (doAddGifts || doRemoveGifts) {
      }
      const cartRuleMessages = enforceCartRules(cartData);
      if (cartRuleMessages.length > 0) {
        showCartRulesNotification(cartRuleMessages);
      }
      publish(
        PUB_SUB_EVENTS.cartMutationComplete,
        PUB_SUB_PAYLOADS[PUB_SUB_EVENTS.cartMutationComplete]({
          cartData
        })
      );
      publish(
        PUB_SUB_EVENTS.cartInFlight,
        PUB_SUB_PAYLOADS[PUB_SUB_EVENTS.cartInFlight]({
          isInFlight: false,
          id,
          line
        })
      );
      if (isCartPage && cartRaw.item_count === 0) {
        window.location.reload();
      } else {
        replaceSections(sectionsToRender, resJson.sections);
      }
    } else if (res.status === 422) {
      throw new Error(res.statusText);
    } else {
      throw new Error(res.statusText);
    }
  } catch (err) {
    console.error(err);
    publish(
      PUB_SUB_EVENTS.cartInFlight,
      PUB_SUB_PAYLOADS[PUB_SUB_EVENTS.cartInFlight]({
        isInFlight: false,
        id,
        line
      })
    );
    publish(
      PUB_SUB_EVENTS.cartMutationError,
      PUB_SUB_PAYLOADS[PUB_SUB_EVENTS.cartMutationError]({
        message: err?.message ?? "Cart update failed. Please try again."
      })
    );
  } finally {
  }
}
var mutateCartDebounce = debounce(({ action, payload, line, id }) => {
  mutateCartAndPublish({ action, payload, line, id });
}, ON_CHANGE_DEBOUNCE_TIMER);
async function cartAdd({
  variantArray = [
    {
      id: 0,
      quantity: 0,
      selling_plan: null,
      properties: {
        [PRODUCT_PROPERTY_KEYS.size]: "",
        [PRODUCT_PROPERTY_KEYS.orderInitiatedBy]: "user"
      }
    }
  ]
}) {
  const payload = {
    items: variantArray.map((lineItem) => ({
      ...lineItem,
      properties: {
        ...lineItem.properties,
        // default property/value for all line items added via user interaction with website; presently used only for benefit of murad-4069, to allow Passport Global (vendor that fills orders for Canada) to discern between original web orders and recurring orders created in Shopify via subscription;
        [PRODUCT_PROPERTY_KEYS.orderInitiatedBy]: lineItem.properties?.[PRODUCT_PROPERTY_KEYS.orderInitiatedBy] ?? "user"
      }
    }))
  };
  mutateCartDebounce({ action: "add", payload });
}
async function cartChange2({ id, line, quantity, sellingPlanId, properties }) {
  let currentProperties = {};
  if (properties) {
    currentProperties = await cartDataFncs.getItemPropertiesByItemKey(id);
  }
  const payload = {
    // id can be line item key or variant id: https://shopify.dev/docs/api/ajax/reference/cart#post-locale-cart-change-js
    id,
    line,
    quantity,
    selling_plan: sellingPlanId,
    ...properties && { properties: { ...currentProperties, ...properties } }
  };
  mutateCartDebounce({ action: "change", payload, line, id });
}
async function cartUpdate({ variantQuantityMap }) {
  const payload = { updates: variantQuantityMap };
  mutateCartDebounce({ action: "update", payload });
}
async function cartClear() {
  const payload = null;
  mutateCartDebounce({ action: "clear", payload });
}
var cartHub = {
  cartAdd,
  cartChange: cartChange2,
  cartUpdate,
  cartClear
};
subscribe(PUB_SUB_EVENTS.cartAddRequest, cartHub.cartAdd, "cartHub");
subscribe(PUB_SUB_EVENTS.cartChangeRequest, cartHub.cartChange, "cartHub");
subscribe(PUB_SUB_EVENTS.cartUpdateRequest, cartHub.cartUpdate, "cartHub");
subscribe(PUB_SUB_EVENTS.cartClearRequest, cartHub.cartClear, "cartHub");

// src/js/cart/afterpay.js
var MIN_AFTERPAY_CART_TOTAL = 3500;
var MAX_AFTERPAY_CART_TOTAL = 1e5;
var afterpayCheckTimeout = null;
function checkForAfterPayTotalPrice(cartIncludesSubscription = false) {
  const showAfterpay = window.afterpay_cart_total_price >= MIN_AFTERPAY_CART_TOTAL && window.afterpay_cart_total_price <= MAX_AFTERPAY_CART_TOTAL && !cartIncludesSubscription;
  const afterpayParentEls = document.querySelectorAll("div.afterpay-parent");
  if (afterpayParentEls.length > 0) {
    const classNameHideAfterpay = "hide-afterpay";
    afterpayParentEls.forEach((parent) => {
      if (showAfterpay) {
        parent.classList.remove(classNameHideAfterpay);
      } else {
        parent.classList.add(classNameHideAfterpay);
      }
    });
  }
}
function doesCartIncludeSubscription(cartRaw) {
  return cartRaw.items?.some(
    (item) => item.selling_plan_allocation !== void 0
  );
}
function debouncedCheckForAfterPayTotalPrice({ cartData }) {
  const { cartRaw } = cartData;
  if (afterpayCheckTimeout) {
    clearTimeout(afterpayCheckTimeout);
    afterpayCheckTimeout = null;
  }
  afterpayCheckTimeout = setTimeout(() => {
    checkForAfterPayTotalPrice(doesCartIncludeSubscription(cartRaw));
  }, 1e3);
}
async function handlePageLoad() {
  const cartData = await getCartData();
  if (!cartData) {
    cartDebug("afterpay.js: no cart data on page load");
    return;
  }
  checkForAfterPayTotalPrice(
    doesCartIncludeSubscription(cartData.cartRaw)
  );
}
document.addEventListener("DOMContentLoaded", () => {
  handlePageLoad();
});
subscribe(
  PUB_SUB_EVENTS.cartMutationComplete,
  debouncedCheckForAfterPayTotalPrice,
  "afterpay"
);

// src/js/cart/cartRules.test-console.js
(function() {
  if (localStorage.getItem("muradCartDebug") !== "2" && localStorage.getItem("muradCartDebug") !== "3") {
    return;
  }
  const CONFIG = {
    // Variant IDs
    PAID_VARIANT_ID: null,
    // ← replace with a paid variant ID
    FREE_VARIANT_ID_1: null,
    // ← replace with a zero-dollar variant ID
    FREE_VARIANT_ID_2: null,
    // ← replace with a *different* zero-dollar variant ID
    // Rule 1 — paid item qty cap
    RULE_1_ENABLED: true,
    RULE_1_SETUP_QTY: 8,
    // quantity forced via direct API (must exceed RULE_1_CAP)
    RULE_1_CAP: 6,
    // expected enforced maximum (matches MAX_QTY_PER_LINE_ITEM in cartRules.js)
    // Rule 2 — zero-dollar item qty cap
    RULE_2_ENABLED: true,
    RULE_2_SETUP_QTY: 3,
    // quantity forced via direct API (must exceed RULE_2_CAP)
    RULE_2_CAP: 1,
    // expected enforced maximum (matches MAX_QTY_PER_ZERO_DOLLAR_LINE_ITEM in cartRules.js)
    // Rule 3 — duplicate zero-dollar variant collapsed to one line item
    RULE_3_ENABLED: true,
    // Rule 4 — total zero-dollar qty cap across all line items
    RULE_4_ENABLED: true,
    RULE_4_SETUP_QTY: 6,
    // quantity forced per free variant (two variants used, so total = RULE_4_SETUP_QTY * 2)
    RULE_4_CAP: 10,
    // expected enforced maximum total (matches MAX_TOTAL_ZERO_DOLLAR_QTY in cartRules.js)
    // Rule 5 — zero-dollar-only cart is cleared
    RULE_5_ENABLED: true,
    // Interactive variant selection
    // When true, selectVariantsInteractively() will prompt you to add each required
    // variant to your cart before tests run, rather than requiring IDs up front.
    // runAllTests() calls this automatically when enabled.
    USE_INTERACTIVE_VARIANT_SELECTION: true
  };
  const LS_VARIANTS_KEY = "muradCartRulesTestVariants";
  function loadCachedVariants() {
    try {
      const cached = JSON.parse(localStorage.getItem(LS_VARIANTS_KEY));
      if (cached && cached.PAID_VARIANT_ID && cached.FREE_VARIANT_ID_1 && cached.FREE_VARIANT_ID_2) {
        CONFIG.PAID_VARIANT_ID = cached.PAID_VARIANT_ID;
        CONFIG.FREE_VARIANT_ID_1 = cached.FREE_VARIANT_ID_1;
        CONFIG.FREE_VARIANT_ID_2 = cached.FREE_VARIANT_ID_2;
        console.log("\u2139\uFE0F  Loaded cached variant IDs from localStorage:", {
          PAID_VARIANT_ID: CONFIG.PAID_VARIANT_ID,
          FREE_VARIANT_ID_1: CONFIG.FREE_VARIANT_ID_1,
          FREE_VARIANT_ID_2: CONFIG.FREE_VARIANT_ID_2
        });
      }
    } catch (_) {
    }
  }
  function saveCachedVariants() {
    localStorage.setItem(LS_VARIANTS_KEY, JSON.stringify({
      PAID_VARIANT_ID: CONFIG.PAID_VARIANT_ID,
      FREE_VARIANT_ID_1: CONFIG.FREE_VARIANT_ID_1,
      FREE_VARIANT_ID_2: CONFIG.FREE_VARIANT_ID_2
    }));
  }
  function clearCachedVariants() {
    localStorage.removeItem(LS_VARIANTS_KEY);
    CONFIG.PAID_VARIANT_ID = null;
    CONFIG.FREE_VARIANT_ID_1 = null;
    CONFIG.FREE_VARIANT_ID_2 = null;
    console.log("\u{1F5D1}\uFE0F  Cached variant IDs cleared. Run selectVariantsInteractively() or set them manually.");
  }
  loadCachedVariants();
  const wait = (ms) => new Promise((r) => setTimeout(r, ms));
  async function waitForCart(predicate, maxMs = 5e3, intervalMs = 200) {
    const deadline = Date.now() + maxMs;
    let cart;
    do {
      await wait(intervalMs);
      cart = await getCart2();
    } while (!predicate(cart) && Date.now() < deadline);
    return cart;
  }
  async function getCart2() {
    const res = await fetch("/cart.js");
    return res.json();
  }
  async function directAdd(items) {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items })
    });
    return res.json();
  }
  async function directUpdate(updates) {
    const res = await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates })
    });
    return res.json();
  }
  async function clearCart() {
    await fetch("/cart/clear.js", { method: "POST" });
    console.log("\u{1F9F9} Cart cleared.");
  }
  function logCart(cart) {
    console.table(
      cart.items.map((i) => ({
        title: i.title,
        variant_id: i.variant_id,
        key: i.key,
        quantity: i.quantity,
        original_price: i.original_price
      }))
    );
    console.log(
      `  item_count: ${cart.item_count} | total_price: ${cart.total_price} (cents)`
    );
  }
  function validateConfig() {
    const VARIANT_ID_KEYS = ["PAID_VARIANT_ID", "FREE_VARIANT_ID_1", "FREE_VARIANT_ID_2"];
    const keysToCheck = CONFIG.USE_INTERACTIVE_VARIANT_SELECTION ? Object.keys(CONFIG).filter((k) => !VARIANT_ID_KEYS.includes(k)) : Object.keys(CONFIG);
    const missing = keysToCheck.filter((k) => CONFIG[k] === 0).map((k) => k);
    if (missing.length) {
      console.log(
        "\u274C Fill in CONFIG values before running tests:",
        missing
      );
      return false;
    }
    if (!window.muradCartActions?.cartRefresh) {
      console.log(
        "\u274C window.muradCartActions not found \u2014 is this the right page/store?"
      );
      return false;
    }
    return true;
  }
  async function testRule1() {
    if (!CONFIG.RULE_1_ENABLED) {
      console.log("Rule 1 \u2014 skipped (RULE_1_ENABLED is false)");
      return { name: "Rule 1", skipped: true };
    }
    console.group(`Rule 1 \u2014 paid item qty capped at ${CONFIG.RULE_1_CAP}`);
    await clearCart();
    await directAdd([{ id: CONFIG.PAID_VARIANT_ID, quantity: 1 }]);
    await directUpdate({ [CONFIG.PAID_VARIANT_ID]: CONFIG.RULE_1_SETUP_QTY });
    const before = await getCart2();
    console.log(`BEFORE enforcement (expect qty ${CONFIG.RULE_1_SETUP_QTY}):`);
    logCart(before);
    const beforeItem = before.items.find((i) => i.variant_id == CONFIG.PAID_VARIANT_ID);
    if (!beforeItem || beforeItem.quantity !== CONFIG.RULE_1_SETUP_QTY) {
      const got = beforeItem ? `qty ${beforeItem.quantity}` : "item not found";
      console.log(`\u23ED\uFE0F SKIP: pre-condition not met \u2014 expected paid item at qty ${CONFIG.RULE_1_SETUP_QTY}, got ${got}`);
      console.groupEnd();
      return { name: "Rule 1", skipped: true, reason: `pre-condition: ${got}` };
    }
    window.muradCartActions.cartRefresh();
    console.log("Polling for enforcement result\u2026");
    const after = await waitForCart(
      (cart) => {
        const item2 = cart.items.find((i) => i.variant_id == CONFIG.PAID_VARIANT_ID);
        return item2 && item2.quantity <= CONFIG.RULE_1_CAP;
      }
    );
    console.log(`AFTER enforcement (expect qty ${CONFIG.RULE_1_CAP}):`);
    logCart(after);
    const item = after.items.find(
      (i) => i.variant_id == CONFIG.PAID_VARIANT_ID
    );
    const passed = item?.quantity === CONFIG.RULE_1_CAP;
    if (passed) {
      console.log("\u2705 PASS");
    } else {
      console.log(`\u274C FAIL: expected qty ${CONFIG.RULE_1_CAP}, got ${item?.quantity}`);
      console.log("BEFORE (full):", before);
      console.log("AFTER (full):", after);
    }
    console.assert(passed, `FAIL: expected qty ${CONFIG.RULE_1_CAP}, got ${item?.quantity}`);
    console.groupEnd();
    return { name: "Rule 1", passed };
  }
  async function testRule2() {
    if (!CONFIG.RULE_2_ENABLED) {
      console.log("Rule 2 \u2014 skipped (RULE_2_ENABLED is false)");
      return { name: "Rule 2", skipped: true };
    }
    console.group(`Rule 2 \u2014 zero-dollar item qty capped at ${CONFIG.RULE_2_CAP}`);
    await clearCart();
    await directAdd([
      { id: CONFIG.PAID_VARIANT_ID, quantity: 1 },
      { id: CONFIG.FREE_VARIANT_ID_1, quantity: 1 }
    ]);
    await directUpdate({ [CONFIG.FREE_VARIANT_ID_1]: CONFIG.RULE_2_SETUP_QTY });
    const before = await getCart2();
    console.log(`BEFORE enforcement (expect free item qty ${CONFIG.RULE_2_SETUP_QTY}):`);
    logCart(before);
    const beforeItem = before.items.find((i) => i.variant_id == CONFIG.FREE_VARIANT_ID_1);
    if (!beforeItem || beforeItem.quantity !== CONFIG.RULE_2_SETUP_QTY) {
      const got = beforeItem ? `qty ${beforeItem.quantity}` : "item not found";
      console.log(`\u23ED\uFE0F SKIP: pre-condition not met \u2014 expected free item at qty ${CONFIG.RULE_2_SETUP_QTY}, got ${got}`);
      console.groupEnd();
      return { name: "Rule 2", skipped: true, reason: `pre-condition: ${got}` };
    }
    window.muradCartActions.cartRefresh();
    console.log("Polling for enforcement result\u2026");
    const after = await waitForCart(
      (cart) => {
        const item2 = cart.items.find((i) => i.variant_id == CONFIG.FREE_VARIANT_ID_1);
        return item2 && item2.quantity <= CONFIG.RULE_2_CAP;
      }
    );
    console.log(`AFTER enforcement (expect free item qty ${CONFIG.RULE_2_CAP}):`);
    logCart(after);
    const item = after.items.find(
      (i) => i.variant_id == CONFIG.FREE_VARIANT_ID_1
    );
    const passed = item?.quantity === CONFIG.RULE_2_CAP;
    if (passed) {
      console.log("\u2705 PASS");
    } else {
      console.log(`\u274C FAIL: expected qty ${CONFIG.RULE_2_CAP}, got ${item?.quantity}`);
      console.log("BEFORE (full):", before);
      console.log("AFTER (full):", after);
    }
    console.assert(passed, `FAIL: expected qty ${CONFIG.RULE_2_CAP}, got ${item?.quantity}`);
    console.groupEnd();
    return { name: "Rule 2", passed };
  }
  async function testRule3() {
    if (!CONFIG.RULE_3_ENABLED) {
      console.log("Rule 3 \u2014 skipped (RULE_3_ENABLED is false)");
      return { name: "Rule 3", skipped: true };
    }
    console.group("Rule 3 \u2014 duplicate zero-dollar variant removed");
    await clearCart();
    await directAdd([{ id: CONFIG.PAID_VARIANT_ID, quantity: 1 }]);
    await directAdd([
      { id: CONFIG.FREE_VARIANT_ID_1, quantity: 1, properties: { _test: "a" } }
    ]);
    await directAdd([
      { id: CONFIG.FREE_VARIANT_ID_1, quantity: 1, properties: { _test: "b" } }
    ]);
    const before = await getCart2();
    const dupCount = before.items.filter(
      (i) => i.variant_id == CONFIG.FREE_VARIANT_ID_1
    ).length;
    console.log(
      `BEFORE enforcement (${dupCount} line item(s) for free variant \u2014 need 2 to test Rule 3):`
    );
    logCart(before);
    if (dupCount < 2) {
      console.log("\u23ED\uFE0F SKIP: pre-condition not met \u2014 Shopify merged the two adds into one line item. This variant does not support differing properties; try a different free variant or test against a real Yotpo/Swell redemption.");
      console.groupEnd();
      return { name: "Rule 3", skipped: true, reason: "pre-condition: Shopify merged duplicate adds into one line item" };
    }
    window.muradCartActions.cartRefresh();
    console.log("Polling for enforcement result\u2026");
    const after = await waitForCart(
      (cart) => cart.items.filter((i) => i.variant_id == CONFIG.FREE_VARIANT_ID_1).length === 1
    );
    const afterCount = after.items.filter(
      (i) => i.variant_id == CONFIG.FREE_VARIANT_ID_1
    ).length;
    console.log(
      `AFTER enforcement (expect 1 line item for free variant, got ${afterCount}):`
    );
    logCart(after);
    const passed = afterCount === 1;
    if (passed) {
      console.log("\u2705 PASS");
    } else {
      console.log(`\u274C FAIL: expected 1 line item, got ${afterCount}`);
      console.log("BEFORE (full):", before);
      console.log("AFTER (full):", after);
    }
    console.assert(passed, `FAIL: expected 1 line item, got ${afterCount}`);
    console.groupEnd();
    return { name: "Rule 3", passed };
  }
  async function testRule4() {
    if (!CONFIG.RULE_4_ENABLED) {
      console.log("Rule 4 \u2014 skipped (RULE_4_ENABLED is false)");
      return { name: "Rule 4", skipped: true };
    }
    console.group(`Rule 4 \u2014 total zero-dollar qty capped at ${CONFIG.RULE_4_CAP}`);
    await clearCart();
    await directAdd([{ id: CONFIG.PAID_VARIANT_ID, quantity: 1 }]);
    await directAdd([
      { id: CONFIG.FREE_VARIANT_ID_1, quantity: 1 },
      { id: CONFIG.FREE_VARIANT_ID_2, quantity: 1 }
    ]);
    await directUpdate({
      [CONFIG.FREE_VARIANT_ID_1]: CONFIG.RULE_4_SETUP_QTY,
      [CONFIG.FREE_VARIANT_ID_2]: CONFIG.RULE_4_SETUP_QTY
    });
    const before = await getCart2();
    const totalFreeBefore = before.items.filter((i) => i.original_price === 0).reduce((sum, i) => sum + i.quantity, 0);
    const expectedSetupTotal = CONFIG.RULE_4_SETUP_QTY * 2;
    console.log(
      `BEFORE enforcement (total free qty: ${totalFreeBefore}, expect ${expectedSetupTotal}):`
    );
    logCart(before);
    if (totalFreeBefore !== expectedSetupTotal) {
      console.log(`\u23ED\uFE0F SKIP: pre-condition not met \u2014 expected total free qty ${expectedSetupTotal}, got ${totalFreeBefore}`);
      console.groupEnd();
      return { name: "Rule 4", skipped: true, reason: `pre-condition: total free qty ${totalFreeBefore}` };
    }
    window.muradCartActions.cartRefresh();
    console.log("Polling for enforcement result\u2026");
    const after = await waitForCart(
      (cart) => cart.items.filter((i) => i.original_price === 0).reduce((sum, i) => sum + i.quantity, 0) <= CONFIG.RULE_4_CAP
    );
    const totalFreeAfter = after.items.filter((i) => i.original_price === 0).reduce((sum, i) => sum + i.quantity, 0);
    console.log(
      `AFTER enforcement (total free qty: ${totalFreeAfter}, expect <= ${CONFIG.RULE_4_CAP}):`
    );
    logCart(after);
    const passed = totalFreeAfter <= CONFIG.RULE_4_CAP;
    if (passed) {
      console.log("\u2705 PASS");
    } else {
      console.log(`\u274C FAIL: total free qty ${totalFreeAfter} exceeds ${CONFIG.RULE_4_CAP}`);
      console.log("BEFORE (full):", before);
      console.log("AFTER (full):", after);
    }
    console.assert(
      passed,
      `FAIL: total free qty ${totalFreeAfter} exceeds ${CONFIG.RULE_4_CAP}`
    );
    console.groupEnd();
    return { name: "Rule 4", passed };
  }
  async function testRule5() {
    if (!CONFIG.RULE_5_ENABLED) {
      console.log("Rule 5 \u2014 skipped (RULE_5_ENABLED is false)");
      return { name: "Rule 5", skipped: true };
    }
    console.group("Rule 5 \u2014 zero-dollar-only cart is cleared");
    await clearCart();
    await directAdd([{ id: CONFIG.FREE_VARIANT_ID_1, quantity: 1 }]);
    const before = await getCart2();
    console.log(
      `BEFORE enforcement (total_price: ${before.total_price}, expect 0; item_count: ${before.item_count}):`
    );
    logCart(before);
    if (before.total_price !== 0 || before.item_count === 0) {
      const reason = before.item_count === 0 ? "cart is empty (free item failed to add)" : `cart has non-zero total_price ${before.total_price} (item may not be zero-dollar)`;
      console.log(`\u23ED\uFE0F SKIP: pre-condition not met \u2014 ${reason}`);
      console.groupEnd();
      return { name: "Rule 5", skipped: true, reason };
    }
    window.muradCartActions.cartRefresh();
    console.log("Polling for enforcement result\u2026");
    const after = await waitForCart((cart) => cart.item_count === 0);
    console.log(
      `AFTER enforcement (item_count: ${after.item_count}, expect 0):`
    );
    logCart(after);
    const passed = after.item_count === 0;
    if (passed) {
      console.log("\u2705 PASS");
    } else {
      console.log(`\u274C FAIL: expected empty cart, got ${after.item_count} items`);
      console.log("BEFORE (full):", before);
      console.log("AFTER (full):", after);
    }
    console.assert(passed, `FAIL: expected empty cart, got ${after.item_count} items`);
    console.groupEnd();
    return { name: "Rule 5", passed };
  }
  async function selectVariantsInteractively() {
    const POLL_INTERVAL_MS = 1500;
    const POLL_TIMEOUT_MS = 9e4;
    const PROMPTS = [
      {
        key: "PAID_VARIANT_ID",
        instruction: "Add any PAID item (original_price > 0) to your cart now, then wait\u2026",
        validate: (item) => item.original_price > 0,
        errorHint: "The item added has original_price === 0. Please add a paid product."
      },
      {
        key: "FREE_VARIANT_ID_1",
        instruction: "Add a ZERO-DOLLAR item (free sample / GWP) to your cart now, then wait\u2026",
        validate: (item) => item.original_price === 0,
        errorHint: "The item added has original_price > 0. Please add a free/zero-dollar product."
      },
      {
        key: "FREE_VARIANT_ID_2",
        instruction: "Add a SECOND, DIFFERENT zero-dollar item to your cart now, then wait\u2026",
        validate: (item) => item.original_price === 0,
        errorHint: "The item added has original_price > 0. Please add a free/zero-dollar product."
      }
    ];
    console.group("\u{1F527} Interactive variant selection");
    console.log(
      "Each step will wait up to " + POLL_TIMEOUT_MS / 1e3 + " s for you to add an item.\nThe cart will be cleared before the tests begin \u2014 your additions here are temporary."
    );
    const capturedVariantIds = /* @__PURE__ */ new Set();
    for (const prompt of PROMPTS) {
      const snapshot = await getCart2();
      const knownIds = /* @__PURE__ */ new Set([
        ...snapshot.items.map((i) => String(i.variant_id)),
        ...capturedVariantIds
      ]);
      console.log(`
\u{1F449} [${prompt.key}] ${prompt.instruction}`);
      const newItem = await (async () => {
        const deadline = Date.now() + POLL_TIMEOUT_MS;
        while (Date.now() < deadline) {
          await wait(POLL_INTERVAL_MS);
          const current = await getCart2();
          const added = current.items.find(
            (i) => !knownIds.has(String(i.variant_id))
          );
          if (added)
            return added;
        }
        return null;
      })();
      if (!newItem) {
        console.log(`\u274C Timed out waiting for ${prompt.key}. Aborting interactive selection.`);
        console.groupEnd();
        return false;
      }
      if (!prompt.validate(newItem)) {
        console.log(
          `\u274C Unexpected item added for ${prompt.key}: "${newItem.title}" (original_price: ${newItem.original_price}).`,
          prompt.errorHint
        );
        console.groupEnd();
        return false;
      }
      CONFIG[prompt.key] = newItem.variant_id;
      capturedVariantIds.add(String(newItem.variant_id));
      console.log(
        `  \u2705 ${prompt.key} set to ${newItem.variant_id} ("${newItem.title}")`
      );
    }
    console.log("\nAll variant IDs captured:", {
      PAID_VARIANT_ID: CONFIG.PAID_VARIANT_ID,
      FREE_VARIANT_ID_1: CONFIG.FREE_VARIANT_ID_1,
      FREE_VARIANT_ID_2: CONFIG.FREE_VARIANT_ID_2
    });
    saveCachedVariants();
    console.log("\u{1F4BE} Variant IDs saved to localStorage \u2014 won't need to re-select next run.");
    console.groupEnd();
    return true;
  }
  async function runAllTests() {
    const variantIdsDefined = CONFIG.PAID_VARIANT_ID !== null && CONFIG.FREE_VARIANT_ID_1 !== null && CONFIG.FREE_VARIANT_ID_2 !== null;
    if (CONFIG.USE_INTERACTIVE_VARIANT_SELECTION && !variantIdsDefined) {
      const ok = await selectVariantsInteractively();
      if (!ok)
        return;
    } else if (variantIdsDefined) {
      console.log("\u2139\uFE0F  Variant IDs already set \u2014 skipping interactive selection.");
    }
    if (!validateConfig())
      return;
    console.group("\u{1F9EA} Cart Rules \u2014 Full Test Suite");
    const results = [
      await testRule1(),
      await testRule2(),
      await testRule3(),
      await testRule4(),
      await testRule5()
    ].filter(Boolean);
    await clearCart();
    console.log("Suite complete. Cart cleared.");
    const passed = results.filter((r) => r.passed === true);
    const failed = results.filter((r) => r.passed === false);
    const skipped = results.filter((r) => r.skipped);
    console.group(
      `\u{1F4CB} Results: ${passed.length} passed, ${failed.length} failed, ${skipped.length} skipped`
    );
    results.forEach((r) => {
      if (r.skipped)
        console.log(`  \u23ED\uFE0F  SKIP \u2014 ${r.name}`);
      else if (r.passed)
        console.log(`  \u2705 PASS \u2014 ${r.name}`);
      else
        console.log(`  \u274C FAIL \u2014 ${r.name}`);
    });
    console.groupEnd();
    console.groupEnd();
  }
  window._cartRulesTest = {
    CONFIG,
    testRule1,
    testRule2,
    testRule3,
    testRule4,
    testRule5,
    runAllTests,
    selectVariantsInteractively,
    clearCachedVariants,
    clearCart,
    getCart: getCart2
  };
  console.log(
    [
      "Cart rules test helpers loaded on window._cartRulesTest.",
      "",
      "  Option A \u2014 provide variant IDs manually:",
      "    window._cartRulesTest.CONFIG.PAID_VARIANT_ID   = <id>",
      "    window._cartRulesTest.CONFIG.FREE_VARIANT_ID_1 = <id>",
      "    window._cartRulesTest.CONFIG.FREE_VARIANT_ID_2 = <id>",
      "    window._cartRulesTest.runAllTests()",
      "",
      "  Option B \u2014 select variants interactively (add items to cart when prompted):",
      "    window._cartRulesTest.CONFIG.USE_INTERACTIVE_VARIANT_SELECTION = true",
      "    window._cartRulesTest.runAllTests()  // prompts before tests run",
      "    // or run the selection step alone:",
      "    window._cartRulesTest.selectVariantsInteractively()",
      "    // IDs are cached in localStorage after selection \u2014 won't prompt again until cleared:",
      "    window._cartRulesTest.clearCachedVariants()  // clears cache + resets CONFIG IDs",
      "",
      "  Run a single test: window._cartRulesTest.testRule1()",
      "",
      "  Tip \u2014 inspect variant IDs in the current cart:",
      "    fetch('/cart.js').then(r=>r.json()).then(c=>console.table(c.items.map(i=>({title:i.title,variant_id:i.variant_id,original_price:i.original_price}))))"
    ].join("\n")
  );
})();

// src/global.vbt.js
window.logout = async function() {
  const res = await fetch("/account/logout/");
  if (res.status === 200) {
    location = "/account/login/?logged_out=true";
  }
};
document.addEventListener(
  "DOMContentLoaded",
  async function globalComponents() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("disableSignup")) {
      if (urlParams.get("disableSignup") == "1") {
        document.cookie = "disableSignup=1";
      }
    }
    if (document.querySelectorAll("[data-login-modal]")) {
      document.querySelectorAll("[data-login-modal]").forEach(
        (login) => login.addEventListener("click", () => {
          if (window.innerWidth < 1024) {
            document.querySelector("#account-modal--mobile").checked = true;
          } else {
            document.querySelector("#account-modal--desktop").checked = true;
          }
          if (login.hasAttribute("data-create-account")) {
            document.querySelector("#register--desktop").checked = true;
          } else if (login.hasAttribute("data-sign-in")) {
            document.querySelector("#register--desktop").checked = false;
          }
        })
      );
    }
    if (window.location.href.includes("cart=open")) {
      document.querySelector("#cart-drawer-toggle").checked = true;
    }
    handleScrollLock();
    handleSwell();
    handleYotpoStyles();
    const components = {};
    if (document.querySelector("[data-countdown]")) {
      const Countdown = await import("./chunk--Countdown-FJ7KFU2G.vbt.js");
      components["countdown"] = Countdown.default;
    }
    if (document.querySelector("[data-gwp]")) {
      const GWP = await import("./chunk--GWP-ILURWMWY.vbt.js");
      components["gwp"] = GWP.default;
    }
    if (document.querySelector("[data-verify-password]")) {
      const VerifyPassword = await import("./chunk--VerifyPassword-XPDFJKY7.vbt.js");
      components["verify-password"] = VerifyPassword.default;
    }
    if (document.querySelector("[data-promo-bar]")) {
      const PromoBar = await import("./chunk--PromoBar-WCNRDM6Y.vbt.js");
      components["promo-bar"] = PromoBar.default;
    }
    if (document.querySelector("[data-ajaxinate]")) {
      const AjaxinateComponent = await import("./chunk--Ajaxinate-5BEN7YRK.vbt.js");
      components["ajaxinate"] = AjaxinateComponent.default;
    }
    ComponentConstructor(components);
    document.dispatchEvent(new CustomEvent("global components loaded"));
    this.removeEventListener("DOMContentLoaded", globalComponents);
  }
);
document.addEventListener(
  "global components loaded",
  async function asyncComponents() {
    const components = {};
    if (document.querySelector("[data-slider]")) {
      const Slider = await import("./chunk--Slider-IJHWQ4FG.vbt.js");
      components["slider"] = Slider.default;
    }
    if (document.querySelector("[data-smooth-scroll]")) {
      const SmoothScroll = await import("./chunk--SmoothScroll-A7TVKOK2.vbt.js");
      components["smooth-scroll"] = SmoothScroll.default;
    }
    if (document.querySelector("[data-intersection-change]")) {
      const ChangeOnIntersection = await import("./chunk--ChangeOnIntersection-LFYXFGY5.vbt.js");
      components["intersection-change"] = ChangeOnIntersection.default;
    }
    if (document.querySelector("[data-accordion]")) {
      const Accordion = await import("./chunk--Accordion-JHYKLMR6.vbt.js");
      components["accordion"] = Accordion.default;
    }
    if (document.querySelector("[data-sticky-cta]")) {
      const StickyCTA = await import("./chunk--StickyCTA-27IXT4TZ.vbt.js");
      components["sticky-cta"] = StickyCTA.default;
    }
    if (document.querySelector("[data-verify-form]")) {
      const VerifyForm = await import("./chunk--VerifyForm-V3JZYEFK.vbt.js");
      components["verify-form"] = VerifyForm.default;
    }
    if (document.querySelector("[data-recharge-widget]")) {
      const RechargeWidget = await import("./chunk--RechargeWidget-YRJES2MK.vbt.js");
      components["recharge-widget"] = RechargeWidget.default;
    }
    if (document.querySelector("[data-tabs]")) {
      const Tabs = await import("./chunk--Tabs-CSEMNJ5D.vbt.js");
      components["tabs"] = Tabs.default;
    }
    if (document.querySelector("[data-estimated-delivery-api]")) {
      const EstimatedDelivery = await import("./chunk--EstimatedDelivery-6MXJYCXP.vbt.js");
      components["estimated-delivery-api"] = EstimatedDelivery.default;
    }
    if (document.querySelector("[data-storemapper-id]")) {
      const Storemapper = await import("./chunk--Storemapper-IN54Q57Z.vbt.js");
      new Storemapper.default().init();
    }
    if (document.querySelector("[data-scroll-to]")) {
      const ScrollTo = await import("./chunk--ScrollTo-7GHXG22R.vbt.js");
      components["scroll-to"] = ScrollTo.default;
    }
    if (document.querySelector("[data-variant]")) {
      const Variant = await import("./chunk--Variant-USVEZEXW.vbt.js");
      components["variant"] = Variant.default;
    }
    ComponentConstructor(components);
    document.dispatchEvent(new CustomEvent("async components loaded"));
    this.removeEventListener("global components loaded", asyncComponents);
  }
);
document.addEventListener(
  "async components loaded",
  async function deferredComponentListeners() {
    const components = {};
    if (document.querySelector("[data-yotpo-rewards]")) {
      const YotpoRewards = await import("./chunk--YotpoRewards-UFMH3OZR.vbt.js");
      components["yotpo-rewards"] = [
        YotpoRewards.default,
        "url:/pages/rewards"
      ];
    }
    if (document.querySelector("[data-searchspring]")) {
      const Searchspring = await import("./chunk--Searchspring-AVQ3JGJ2.vbt.js");
      components["searchspring"] = [
        Searchspring.default,
        "mouseover",
        "url:/collections/",
        "url:/search"
      ];
    }
    if (document.querySelector("[data-filters]")) {
      const Filters = await import("./chunk--Filters-G26NZQIR.vbt.js");
      components["filters"] = Filters.default;
    }
    if (document.querySelector("[data-iframe]")) {
      const IFrame = await import("./chunk--IFrame-ULTPB7IU.vbt.js");
      components["iframe"] = [IFrame.default, "mouseover"];
    }
    if (document.querySelector("[data-range-reveal]")) {
      const RangeReveal = await import("./chunk--RangeReveal-FNVXLKF2.vbt.js");
      components["range-reveal"] = RangeReveal.default;
    }
    if (document.querySelector("[data-predictive-search]")) {
      const PredictiveSearch = await import("./chunk--PredictiveSearch-25OVNKD6.vbt.js");
      components["predictive-search"] = [
        PredictiveSearch.default,
        "mouseover",
        "click"
      ];
    }
    if (document.querySelector("[data-product-form]")) {
      const ProductForm = await import("./chunk--ProductForm-56FRCFCK.vbt.js");
      components["product-form"] = [
        ProductForm.default,
        "mouseover",
        "url:/products/"
      ];
    }
    ComponentConstructor(components);
    this.removeEventListener(
      "async components loaded",
      deferredComponentListeners
    );
  }
);
document.addEventListener(
  "deferred component listeners attached",
  async function asyncComponents2() {
    const components = {};
    ComponentConstructor(components);
    document.removeEventListener(
      "deferred component listeners attached",
      asyncComponents2
    );
    this.removeEventListener("async components loaded", asyncComponents2);
  }
);
function handleScrollLock() {
  document.querySelectorAll("[data-scroll-lock]").forEach((el) => {
    el.addEventListener("change", function() {
      if (this.checked) {
        document.body.setAttribute("style", "overflow:hidden;");
      } else {
        document.body.removeAttribute("style");
      }
      if (el.id === "search-modal-toggle") {
        document.querySelector("#search").focus();
      }
      if (el.id === "account-modal--mobile") {
        document.querySelector("#account-modal--mobile--content").style.height = window.innerHeight + "px";
      }
    });
  });
}
function handleSwell() {
  const STORE_KEY = "muradYotpoPoints";
  const store = window[STORE_KEY] = window[STORE_KEY] || {
    balance: null,
    setBalance(value) {
      if (typeof value !== "number" || Number.isNaN(value)) {
        return;
      }
      this.balance = value;
      updatePointNodes(value);
    },
    adjustBalance(delta) {
      if (typeof this.balance !== "number")
        return;
      const next = Math.max(this.balance + delta, 0);
      this.setBalance(next);
    }
  };
  const rewardTracker = {
    active: /* @__PURE__ */ new Map()
  };
  function updatePointNodes(balance) {
    document.querySelectorAll("[data-yotpo-points]").forEach((el) => {
      el.innerHTML = balance.toLocaleString();
      const parent = el.parentElement?.hasAttribute("data-hide-container") && el.parentElement;
      const wrapper = parent || el.closest("[data-hide-container]");
      if (wrapper) {
        wrapper.style.removeProperty("display");
        wrapper.style.removeProperty("opacity");
      }
    });
  }
  function getRewardCost(item) {
    const costKeys = [
      "_yotpo_redemption_points_cost",
      "_swell_points_used",
      "_yotpo_points_cost"
    ];
    for (const key of costKeys) {
      const raw = item?.properties?.[key];
      if (raw === void 0 || raw === null || raw === "")
        continue;
      const cost = parseInt(raw, 10);
      if (!Number.isNaN(cost)) {
        return cost;
      }
    }
    return null;
  }
  function getRewardIdentifier(item) {
    const candidates = [
      item?.properties?._yotpo_redemption_option_id,
      item?.properties?._swell_reward_id,
      item?.key,
      item?.id,
      item?.variant_id
    ];
    return candidates.find((candidate) => candidate !== void 0 && candidate !== null);
  }
  function extractRewardMap(items = []) {
    const map = /* @__PURE__ */ new Map();
    items.forEach((item) => {
      const cost = getRewardCost(item);
      const identifier = getRewardIdentifier(item);
      if (cost === null || identifier === void 0)
        return;
      map.set(String(identifier), cost);
    });
    return map;
  }
  function syncRewards(nextMap, { skipAdjust = false } = {}) {
    if (!skipAdjust && typeof store.balance === "number") {
      nextMap.forEach((cost, optionId) => {
        if (!rewardTracker.active.has(optionId)) {
          store.adjustBalance(-cost);
        }
      });
      rewardTracker.active.forEach((cost, optionId) => {
        if (!nextMap.has(optionId)) {
          store.adjustBalance(cost);
          if (typeof window.swellAPI?.removePointRedemptionIdFromCart === "function") {
            window.swellAPI.removePointRedemptionIdFromCart(optionId, () => {
            });
          }
        }
      });
    }
    rewardTracker.active = nextMap;
  }
  async function primeRewards() {
    try {
      const res = await fetch("/cart.js");
      if (!res.ok)
        return;
      const cartJson = await res.json();
      syncRewards(extractRewardMap(cartJson.items), { skipAdjust: true });
    } catch (err) {
      console.error(err);
    }
  }
  subscribe(
    PUB_SUB_EVENTS.cartMutationComplete,
    ({ cartData }) => {
      const items = cartData?.cartRaw?.items;
      if (!items)
        return;
      syncRewards(extractRewardMap(items));
    },
    "yotpo-reward-sync"
  );
  document.addEventListener("swell:setup", () => {
    const { vipTier, pointsBalance } = window.Swell.Customer.getCustomerDetails();
    if (typeof pointsBalance === "number") {
      store.setBalance(pointsBalance);
    }
    if (vipTier) {
      let tier = vipTier.name;
      if (!tier) {
        tier = "Bronze";
      }
      document.querySelectorAll("[data-yotpo-tier]").forEach((el) => {
        el.innerHTML = tier;
        const wrapper = el.closest("[data-hide-container]");
        if (wrapper) {
          wrapper.style.removeProperty("display");
          wrapper.style.removeProperty("opacity");
        }
      });
    }
    if (document.querySelector("#rewards-header")) {
      document.querySelector("#rewards-header").classList.remove("hidden");
    }
    primeRewards();
  });
}
function handleYotpoStyles() {
  new MutationObserver(function() {
    const yotpoTitle = document.querySelector(
      ".yotpo-bottom-line .yotpo-bottom-line-left-panel.yotpo-bottom-line-score"
    );
    if (yotpoTitle) {
      yotpoTitle.style.fontFamily = "NoeDisplay";
      this.disconnect();
    }
  }).observe(document.body, {
    childList: true,
    subtree: true
  });
}
